import React, { Component, createRef, useState } from "react";
import { connect } from "react-redux";
// import copy from "copy-to-clipboard";
import copy from "clipboard-copy";
import { bindActionCreators } from "redux";
import "../style/style.css";
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import CancelSharpIcon from '@mui/icons-material/CancelSharp';
import BookmarkAddedIcon from "@mui/icons-material/BookmarkAdded";
import {
  Container,
  Grid,
  Typography,
  FormGroup,
  Button,
  Link,
  FormControlLabel,
  Switch,
  FormControl,
  InputLabel,
  Select,
  Paper,
  MenuItem,
  Box,
  FormHelperText,
  Slider as MuiSlider,
  Chip,
  Tooltip,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Input,
  Modal,
  TextField,
} from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
// import Slider from '@mui/material/Slider'
import { alpha } from "@mui/material/styles";
import { InputBase } from "@mui/material";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@material-ui/icons/Clear";
// import FileDownloadIcon from "@mui/icons-material/FileDownload";
import MaterialTable from "material-table";
import Icon from "@material-ui/core/Icon";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import imageNotAvailable from "../../../../assests/images/img-soon.png";
import {
  formatDate,
  getComponentActionList,
  isActionAllowed,
  showErrorToast,
  showSuccessToast,
} from "../../../../common/components/Helper/Utils";
import { getCustomLabel } from "../../../../common/components/Helper/Utils";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import {
  fetchInventoryWatches,
  brandList,
  dialColor,
  filterBySearch,
  inventoryDetailById,
  SearchInventoryWatches,
  fetchInventoryExcelList,
  deleteInventories,
  shareInventories,
  sendToShopify,
  sendToEbay,
  getEbayConnectionStatus,
} from "../actions/dashboardAction";
import ShopifySyncResultDialog from "../../../../common/components/ShopifySyncResultDialog";
import { searchLocation } from "../../dealer/actions/dealerAction";
import _ from "lodash";
import searchinventry from "../actions/dashboardaapi";
import plusSign from "../../../../assests/images/Group 1771.png";
import Card from "@material-ui/core/Card";
import InvoiceModal from "./invoiceModal";
import TablePagination from "@mui/material/TablePagination";
import { styled } from "@mui/material/styles";
import Menu from "@mui/material/Menu";
import IconButton from "@material-ui/core/IconButton";
// import CircularProgress from "@material-ui/core/CircularProgress";
import CircularProgress from "@material-ui/core/CircularProgress";
import { toast } from "react-toastify";
import { SpinnerRoundFilled } from "spinners-react";
import CachedIcon from "@material-ui/icons/Cached";
import ViewInvoicemodel from "./ViewInvoicemodel";
import VoidInventory from "./voidInventory";
import VoidItem from "./voidItem";
import {
  voidInventoryUpdate,
  generateLabelPDFRequest,
  getInventorySettingsByAccount,
} from "./../../dashboard/actions/dashboardAction";
import { trim } from "lodash";
import { KeyboardArrowDownOutlined } from "@material-ui/icons";
import CloseIcon from "@material-ui/icons/Close";
// import { th } from "date-fns/locale";
import ContentWrapper from "../../../../common/components/contentWrapper";
import ReasonChange from "./SoldAndUnsoldModel";
import BulkUpload from "@mui/icons-material/UploadFileOutlined";
import Share from "@mui/icons-material/Share";
import constants from "../../../../utils/constants";
import { getInventorySetting } from "../../administration/actions/administration";
import { recoverPassword, verifyOtp } from "../../../Auth/reducer/actions";
import validator from "validator";
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "react-loader-spinner";
import AccessRestricted from "../../common/components/accessRestricted";
import UpgradePlan from "../../common/components/upgradePlan";
import VideoPlayer from "simple-react-video-thumbnail";
import { CircleArrow as ScrollUpButton } from "react-scroll-up-button";
import { Autocomplete } from "@material-ui/lab";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { withStyles } from "@material-ui/core/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import {
  typeFilter,
  inventoryStatusFilter,
  soldStatusFilter,
  inventoryTypeFilter,
  invoiceStatusFilter,
  categoryFilter,
  getInventoryTileFields,
  renderInventoryStatusLabel,
} from "../../../../common/components/Helper/Utils";
import { withRouter } from "react-router-dom";

const styles = (theme) => ({
  customInput: {
    width: "0 !important",
  },
});

const getUsedGood = () => getCustomLabel("custom_used_good", "Used/Good");
const getMintVeryGood = () => getCustomLabel("custom_mint_verygood", "Mint/Very Good");
const getRetailReady = () => getCustomLabel("custom_retail_likenew", "Retail Ready/Like New");
const getNewCond = () => getCustomLabel("custom_new", "New");
const getUsed = () => getCustomLabel("custom_used", "Used");

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
// import Slider from 'react-slick';
const InventoryStatusLookup = {
  2: "Incoming",
  6: "Needs Service / Polish",
  7: "At Service",
  11: "Intake Complete",
  13: "Need to Post",
  12: "Invoiced",
  1: "Inhand",
  3: "Out on Memo",
  4: "On Hold / Reserved",
  8: "Need to Ship",
  9: "Shipped waiting on payment",
  10: "Sold & Cashed Out",
  5: "Available to Order",
};

const ContactTypeOptions = [
  { id: "supplier", value: "Supplier" },
  { id: "partner", value: "Partner" },
  { id: "memo_supplier", value: "Memo Supplier" },
];

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  maxHeight: 600,
  overflowY: "auto",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const textfieldStyle = {
  width: "0 !important",
};

const StyledMenu = styled((props) => (
  <Menu
    // elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));

const columns = [
  { id: "checkbox", label: "" },
  { id: "filtername", label: "Filter Name", minWidth: 100 },
  { id: "sold", label: "Sold/Unsold" },
  { id: "invoicestatus", label: "Paid Status" },
  {
    id: "brand_name",
    label: "Brand",
    minWidth: 100,
  },
  {
    id: "type",
    label: "Type",
    minWidth: 100,
  },
  {
    id: "category",
    label: "Category",
    minWidth: 100,
  },
  {
    id: "inventory_status",
    label: "Inventory Status",
    minWidth: 100,
  },
  {
    id: "inventory_type",
    label: "Inventory Type",
    minWidth: 100,
  },
  {
    id: "setasdefault",
    label: "Is Default",
    minWidth: 100,
  },
];

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const BasicMenu = ({ row, searchWatch, history }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [viewInvoiceModal, setviewInvoiceModal] = useState(false);
  const [voidInventoryModal, setvoidInventoryModal] = useState(false);
  const [purchaseIgnoreReason, setPurchaseIgnoreReason] = useState("");
  const [selectedInventory, setSelectedInventory] = useState(null);
  const [isMemo, setIsMemo] = useState(false);
  const [purchaseExpenseModal, setPurchaseExpenseModal] = useState(false);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setviewInvoiceModal(false);
    setvoidInventoryModal(false);
    setvoidInventoryModal(false);
    setPurchaseExpenseModal(false);
    setSelectedInventory(null);
    setIsMemo(false);
  };

  const viewInvoice = (row, isMemo) => {
    setAnchorEl(null);
    setviewInvoiceModal(!viewInvoiceModal);
    setSelectedInventory(row);
    setIsMemo(isMemo);
  };

  const voidInvoice = (row) => {
    setAnchorEl(null);
    if (row.purchase_expense && Number(row.purchase_expense) > 0) {
      setSelectedInventory(row);
      setPurchaseExpenseModal(true);
      return;
    }
    setvoidInventoryModal(true);
    setSelectedInventory(row);
  };

  const updateInventoryDetails = (reason) => {
    if (trim(reason) !== "") {
      const data = {
        inventoryid: selectedInventory.inventoryid,
        reason: trim(reason),
        purchase_voidreason: trim(purchaseIgnoreReason),
      };
      voidInventoryUpdate(data, (err, response) => {
        if (response) {
          // handleClose(true);
          searchWatch();
          setPurchaseIgnoreReason("");
        }
        if (err) {
          showErrorToast(err);
          setPurchaseIgnoreReason("");
        }
      });
    }
  };
  const voidItemDetails = (purchase_voidreason) => {
    if (trim(purchase_voidreason) !== "") {
      // const data = {
      //   inventoryid: selectedInventory.inventoryid,
      //   purchase_voidreason: trim(purchase_voidreason),
      // };
      const purchaseIgnoreReason = trim(purchase_voidreason);

      openVoidAfterExpense(purchaseIgnoreReason);

      // voidInventoryUpdate(data, (err, response) => {
      //   if (response) {
      //     openVoidAfterExpense();
      //     // searchWatch();
      //   }
      //   if (err) {
      //     showErrorToast(err)
      //   }
      // });
    }
  };
  const openVoidAfterExpense = (purchaseIgnoreReason) => {
    setPurchaseExpenseModal(false);
    setvoidInventoryModal(true);
    setPurchaseIgnoreReason(purchaseIgnoreReason);
  };

  return (
    <div>
      <IconButton
        // className="primary-bg color-white"
        type="button"
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        style={{ marginLeft: "5px", padding: "5px" }}
      >
        <MoreVertIcon />
      </IconButton>
      <StyledMenu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {row.sold !== 1 && row.memoid && row?.inventory_status == 3 ? (
          <MenuItem onClick={() => viewInvoice(row, true)}>
            View Memo Invoice
          </MenuItem>
        ) : (
          row.status === "Active" &&
          row.sold !== 1 && (
            <MenuItem onClick={() => voidInvoice(row)}>Void Inventory</MenuItem>
          )
        )}
        {row.sold === 1 && row.status !== "Void" && (
          <>
            {row.invoiceid && (
              <MenuItem onClick={() => viewInvoice(row, false)}>
                View Invoice
              </MenuItem>
            )}
            {row.memoid && (
              <MenuItem onClick={() => viewInvoice(row, true)}>
                View Memo Invoice
              </MenuItem>
            )}
            {!row.invoiceid && !row.memoid && (
              <MenuItem disabled>Invoice Not Associated</MenuItem>
            )}
          </>
        )}
      </StyledMenu>
      {viewInvoiceModal && (
        <ViewInvoicemodel
          open={viewInvoiceModal}
          handleClose={handleClose}
          invoiceid={{
            id: selectedInventory.invoiceid || null,
            memoid: isMemo ? selectedInventory.memoid : null,
          }}
        />
      )}
      {voidInventoryModal && (
        <VoidInventory
          open={voidInventoryModal}
          handleClose={handleClose}
          inventory={selectedInventory}
          updateInventoryDetails={updateInventoryDetails}
        />
      )}
      {purchaseExpenseModal && (
        <VoidItem
          open={purchaseExpenseModal}
          handleClose={handleClose}
          inventory={selectedInventory}
          voidItemDetails={voidItemDetails}
          onSubmitSuccess={openVoidAfterExpense}
        />
      )}
    </div>
  );
};

const CustomizedUploadMenus = ({ downloadInventory, history }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (data) => {
    setAnchorEl(null);
    if (data) {
      downloadInventory(data);
    }
  };
  const bulUploadStandaWatch = () => {
    history.push({
      pathname: "/bulk-upload",
    });
  };
  const bulUploadMiscBucket = () => {
    history.push({
      pathname: "/misc-bucket-bulk-upload",
    });
  };
  const bulUploadMiscProduct = () => {
    history.push({
      pathname: "/misc-product-bulk-upload",
    });
  };
  return (
    <>
      <Button
        id="demo-customized-button"
        aria-controls={open ? "demo-customized-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        variant="contained"
        disableElevation
        onClick={handleClick}
        className={"text-capitalize primary-bg color-white"}
        style={{ float: "right" }}
        endIcon={<KeyboardArrowDownOutlined />}
      >
        <BulkUpload />
        &nbsp;Bulk Upload
      </Button>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={bulUploadStandaWatch} disableRipple>
          Bulk Upload For Standard Watches
        </MenuItem>
        <MenuItem onClick={bulUploadMiscBucket} disableRipple>
          Bulk Upload For Misc Watches
        </MenuItem>
        <MenuItem onClick={bulUploadMiscProduct} disableRipple>
          Bulk Upload For Misc Products
        </MenuItem>
      </StyledMenu>
    </>
  );
};

const CustomizedMenus = ({ downloadInventory }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (data) => {
    setAnchorEl(null);
    if (data) {
      downloadInventory(data);
    }
  };

  return (
    <>
      <Button
        id="demo-customized-button"
        aria-controls={open ? "demo-customized-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        variant="contained"
        disableElevation
        onClick={handleClick}
        className={"text-capitalize primary-bg color-white"}
        style={{ float: "right" }}
        endIcon={<KeyboardArrowDownOutlined />}
      >
        Download Inventory
      </Button>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={() => handleClose("PDF")} disableRipple>
          Download Pdf
        </MenuItem>
        <MenuItem onClick={() => handleClose("EX")} disableRipple>
          Download Excel
        </MenuItem>
      </StyledMenu>
    </>
  );
};

const followersMarks1 = [
  {
    value: "0",
    scaledValue: 0,
    label: "ALL",
  },
  {
    value: "Unknown",
    scaledValue: 1,
    label: "UNKNOWN",
  },
  {
    value: 30,
    scaledValue: 2,
    label: "30 d",
  },
  {
    value: 60,
    scaledValue: 3,
    label: "60 d",
  },
  {
    value: 90,
    scaledValue: 4,
    label: "90 d",
  },
  {
    value: 120,
    scaledValue: 6,
    label: "120 d",
  },
  {
    value: 150,
    scaledValue: 8,
    label: "150 d",
  },
  {
    value: 180,
    scaledValue: 9,
    label: "180 d",
  },
];

const PriceRangeObj = [
  {
    value: "0",
    scaledValue: 0,
    label: "0",
  },
  // {
  //   value: "Unknown",
  //   scaledValue: 1,
  //   label: "UNKNOWN",
  // },
  {
    value: 5000,
    scaledValue: 2,
    label: "$5k",
  },
  {
    value: 10000,
    scaledValue: 3,
    label: "$ 10k",
  },
  {
    value: 25000,
    scaledValue: 4,
    label: "$ 25k",
  },
  {
    value: 50000,
    scaledValue: 6,
    label: "$ 50k",
  },
  {
    value: 75000,
    scaledValue: 8,
    label: "$ 75k",
  },
  {
    value: 100001,
    scaledValue: 10,
    label: "$ 100k+",
  },
];

class InventoryComponent extends Component {
  constructor(props) {
    super(props);
    this.textRef = React.createRef();
    this.state = {
      render: false,
      searchEnabled: false,
      inventoryid: "",
      productid: "",
      purchaseprice: "",
      // purchasedate: "",
      modledata: "",
      purchasefrom: "",
      CaseSize: "",
      CaseMaterial: "",
      DialColor: "",
      contactName: "",
      contactType: [],
      locationAutoCompleteData: [],
      locationSearch: {},
      openApplyFilter: false,
      filterData: [],
      saveFilter: false,
      setAsDefault: false,
      filterName: "",
      selectedRowIds: [],
      selectedFilterId: null,
      selectedFilterData: null,
      openDeleteConfirmModal: false,
      confirmDefaultFilter: false,
      pendingDefaultFilter: null,
      appliedFilterName: "",
      defaultManuallyCleared: false,
      isNewFilterBeingSaved: false,
      BandMaterial: "",
      disable: "",
      filterEnable: false,
      selectedProduct: { productId: "" },
      sold: true,
      avail: false,
      soldbtn: false,
      BrandName: "",
      brand_id: "",
      brand_description: "",
      InventoryType: "",
      InventoryStatus: "",
      key: "",
      data: [],
      searchString: "",
      nonsearchstring: true,
      updatedInvenentryList: [],
      updateIntiate: false,
      errorMessage: "",
      inventory_id: "",
      listed_on: "all",
      sold_status: "",
      loaded: false,
      UserId: "",
      purchasedate: 0,
      autocomplete: {
        currentInput: "",
        loading: false,
        data: [],
      },
      priceRange: [0, 100001],
      cursor: 0,
      inventoryData: [],
      selected: { product: null },
      copied: false,
      setCopied: false,
      soldStatus: "0",
      paidStatus: "ALL",
      dataSoldUnsold: false,
      removedSoldUnsold: "",
      open: false,
      rowsPerPage: 10,
      page: 0,
      downloadloading: false,
      inventoryxlid: this.props?.match?.params?.bulkUploadId
        ? this.props?.match?.params?.bulkUploadId
        : "",
      anchorE2: null,
      openDropDown: false,
      inventoryStatus: "ALL",
      openE2: false,
      InventoryCategory: null,
      type: "standand_and_misc",
      accessData: null,
      accountId: sessionStorage.getItem("accountId"),
      userData: sessionStorage.getItem("userDetails")
        ? JSON.parse(sessionStorage.getItem("userDetails"))
        : null,
      isShopifyEnabled: sessionStorage.getItem("isShopifyEnabled") === "true",
      isShopifyVerified: sessionStorage.getItem("isShopifyVerified") === "true",
      isEbayEnabled: sessionStorage.getItem("isEbayEnabled") === "true",
      isEbayVerified: sessionStorage.getItem('isEbayVerified') === "true",
      reasonChange: "",
      openReasonChange: false,
      rowDetails: "",
      soldText: "Sold Reason : ",
      unsoldText: "Unsold Reason : ",
      setting: {},
      notforSale: false,
      hoveredCard: null,
      selectedItems: [],
      openDeleteModal: false,
      openOtpModel: false,
      showing: false,
      timerotp: "",
      otp: "",
      otpErrorText: "",
      twoMinutes: 60 * 2,
      isValid: false,
      disabled: false,
      isDeleteAll: false,
      openShareModal: false,
      pagecontent: 100,
      pagenumber: 1,
      noItemFound: null,
      hasMore: false,
      loadingMore: false,
      noOfItemsInventory: 0,
      totalCostforInventory: 0,
      productImage: "ALL",
      selectAll: false,
      modalOpen: false,
      selectedInventoryData: null,
      shopifySyncResult: [],
      showShopifyResultDialog: false,
      inventoryMap: {},
      shopifySyncLoading: false,
      isEbayVerified: false,
      ebaySyncResult: [],
      showEbayResultDialog: false,
      ebaySyncLoading: false,
      invoiceType: "regular_invoice",
      openGenerateLabelDialog: false,
      selectedFile: null,
      selectedLabelFields: [],
      selectedLeftFields: [],
      selectedRightFields: [],
      lastSelectedLeftFields: [],
      lastSelectedRightFields: [],
      startRow: "",
      quantity: "",
      sold_price: "",
      // openGenerateLabelDialog: false,

      // other states...
    };
    this.timerRef = null;
    this.changeRangeName = this.changeRangeName.bind(this);
    this.SearchInventoryWatchesdetails =
      this.SearchInventoryWatchesdetails.bind(this);
    this.handleNotforSaleCheck = this.handleNotforSaleCheck.bind(this);
    this.handleChangeOfBrandByBrandName =
      this.handleChangeOfBrandByBrandName.bind(this);
    this.handleChangeOfInventoryDetailById =
      this.handleChangeOfInventoryDetailById.bind(this);
    this.autocomplete = this.autocomplete.bind(this);
    this.checkboxval = this.checkboxval.bind(this);
    this.removebrandname = this.removebrandname.bind(this);
    this.handleChangeOfPaidStatus = this.handleChangeOfPaidStatus.bind(this);
    this.removePaidStatus = this.removePaidStatus.bind(this);
    this.handleChangeOfSoldUnSold = this.handleChangeOfSoldUnSold.bind(this);
    this.handleEnterEvent = this.handleEnterEvent.bind(this);
    this.removeSoldUnsold = this.removeSoldUnsold.bind(this);
    this.removeBulkUploadId = this.removeBulkUploadId.bind(this);
    this.removeInventoryType = this.removeInventoryType.bind(this);
    this.removeInventoryStatus = this.removeInventoryStatus.bind(this);
    this.handleChangeOfBulkUploadId =
      this.handleChangeOfBulkUploadId.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.downloadInventory = this.downloadInventory.bind(this);
    // this.createInvoice = this.createInvoice(this);
    this.inventoryPurchaseDateInterval =
      this.inventoryPurchaseDateInterval.bind(this);
    this.inventoryPriceRangeInterval =
      this.inventoryPriceRangeInterval.bind(this);
    this.valueLabelFormat = this.valueLabelFormat.bind(this);
    this.showDropdownMenu = this.showDropdownMenu.bind(this);
    this.hideDropdownMenu = this.hideDropdownMenu.bind(this);
    this.handleChangeOfInventoryStatus =
      this.handleChangeOfInventoryStatus.bind(this);
    this.removetype = this.removetype.bind(this);
    this.handleChangeOfDialColor = this.handleChangeOfDialColor.bind(this);
    this.removeInventoryCategory = this.removeInventoryCategory.bind(this);
    // this.removeDialColor = this.removeDialColor.bind(this);
    this.handleCloseOfReasonChange = this.handleCloseOfReasonChange.bind(this);
    this.handleSwitch = this.handleSwitch.bind(this);
    this.getInventorySettingDetails =
      this.getInventorySettingDetails.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.openOtpModel && !prevState.openOtpModel) {
      this.resetTimer();
    }
  }

  resetTimer = () => {
    this.setState({ showing: false, twoMinutes: 60 * 2 }, this.startTimer);
  };

  startTimer = () => {
    if (this.timerRef) {
      clearInterval(this.timerRef);
    }
    let timer = this.state.twoMinutes;
    this.timerRef = setInterval(() => {
      let minutes = parseInt(timer / 60, 10);
      let seconds = parseInt(timer % 60, 10);
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      if (timer > 0) {
        this.setState({
          twoMinutes: `${minutes}:${seconds}`,
        });
      } else {
        clearInterval(this.timerRef);
        this.setState({ showing: true });
      }

      timer -= 1;
    }, 1000);
  };

  componentWillMount() {
    const accessData = getComponentActionList("my_inventory");
    this.setState({ accessData: accessData });
  }

  // componentDidUpdate(prevProps, prevState) {
  //   if (prevState.type !== this.state.type && this.state.type) {
  //     this.SearchInventoryWatchesdetails();
  //   }
  // }

  getInventorySettingDetails() {
    const { pagecontent, pagenumber, type } = this.state;
    getInventorySetting((err, response) => {
      const hasSetting = response?.data?.length > 0;
      const data = hasSetting ? response.data[0] : null;
      // if (response?.data?.length > 0) {
      // const data = response.data[0] || {};
      if (!hasSetting) {
        toast.success(
          "Inventory settings are currently not enabled. Please navigate to Administration → My Inventory and click the Update button to enable them.",
        );
      }
      this.setState(
        (prevState) => ({
          setting: data || {},
          selectedLeftFields: data?.label_left_cols || [],
          selectedRightFields: data?.label_right_cols || [],
          lastSelectedLeftFields: data?.label_left_cols || [],
          lastSelectedRightFields: data?.label_right_cols || [],
          type: type
            ? type
            : // : prevState.appliedFilterName ? prevState.type
            "standand_and_misc",
        }),
        async () => {
          let keySearch = this.state.key;
          let searchData = "";
          if (keySearch) {
            searchData = keySearch.replace(
              /[&\/\\,+!@^&()$~%.'":;-?<>{}]/g,
              "",
            );
            searchData = searchData.replaceAll("-", "");
            searchData = searchData.trim();
          }
          const data = {
            key: searchData,
            dial_color: this.state.DialColor,
            location_id: this.state.locationSearch?.id,
            contactname: this.state.contactName
              ? this.state.contactName.replace(/\s+/g, "")
              : "",
            contacttype: this.state.contactType,
            userid: this.state.userData.userId,
            brand_id: this.state.brand_id,
            brand_name: this.state.brand_description,
            sold: this.state.soldStatus,
            // is_notsale:this.state.notforSale.toString(),
            invoicestatus:
              this.state.paidStatus == "" ? "ALL" : this.state.paidStatus,
            // inventory_status: this.state.inventoryStatus,
            inventoryxlid: this.normalizeInventoryXlId(this.state.inventoryxlid),
            inventory_type: this.state.InventoryType,
            inventory_status: this.state.InventoryStatus,
            purchace_date:
              this.state.purchasedate === 0
                ? "ALL"
                : this.state.purchasedate > 180
                  ? "UNKNOWN"
                  : this.state.purchasedate,
            type: this.state.type,
            category: this.state.InventoryCategory,
            product_image: this.state.productImage,
          };
          if (data.type === "ALL") {
            delete data.type;
          }
          if (data.category === "ALL") {
            delete data.category;
          }
          await this.props.fetchInventoryWatches(
            this.state?.accountId,
            data,
            pagecontent,
            pagenumber,
          );
          this.setState({
            totalCostforInventory: this.props.InventoryList?.totalCost,
            noOfItemsInventory: this.props.InventoryList?.totalInventory,
            noItemFound:
              this.props.InventoryList?.data?.length === 0
                ? "No data found"
                : null,
            hasMore:
              (this.props.InventoryList?.data?.length || 0) >= pagecontent,
            loadingMore: false,
            // }, () => {
            // this.setState({ loaded: hasSetting });
            loaded: true,
          });
        },
      );
      // }
    });
  }
  componentDidMount() {
    getEbayConnectionStatus((err, res) => {
      if (res?.status === 1) {
        this.setState({ isEbayVerified: !!res.data?.isConnected });
      }
    });

    const cache = this.props.location?.state?.inventoryCacheState;
    if (cache) {
      this.setState(
        (prevState) => ({
          ...prevState,
          ...cache,
          loaded: false,
        }),
        () => {
          this.props.brandList();
          this.getLocationAutocomplete();
          this.getFilterDetails(cache).then(() => {
            this.getInventorySettingDetails();
            const hasSelectedTypeFilter =
              this.state.type && this.state.type !== "standand_and_misc";
            if (hasSelectedTypeFilter) {
              this.SearchInventoryWatchesdetails();
            }
          });
        },
      );
    } else {
      this.setState({ loaded: false }, () => {
        this.props.brandList();
        this.getLocationAutocomplete();
        this.getFilterDetails().then(() => {
          this.getInventorySettingDetails();
        });
      });
    }
    // if (this.props.history && this.props.history.location && this.props.history.location.state && this.props.location.state.inventoryCacheState) {
    //   this.setState(prevState => ({
    //     ...prevState,
    //     ...this.props.location.state.inventoryCacheState
    //   }));
    //   setTimeout(() => {
    //     this.SearchInventoryWatchesdetails();
    //   }, 200)
    // }
    // else {
    //   this.setState({
    //     UserId:
    //       this.props && this.props.currentUser && this.props.currentUser.userId,
    //   });
    //   // setTimeout(() => {
    //   //   this.setState({ loaded: true });
    //   // }, 2000);
    //   const token = localStorage.getItem("token");
    //   if (token) {
    //     if (this.props.currentUser) {
    //       // this.props.fetchInventoryWatches(this.state.UserId);
    //     }
    //     let PId = null;
    //     try {
    //       PId = this.props.match.params.productId;
    //       if (PId) {
    //         this.state.selectedProduct.productId = PId;
    //         this.setState({
    //           ...this.state,
    //         });
    //         this.props.fetchSearchBrowseWatches(PId).then(() => {
    //           this.setState({ loaded: true });
    //         }).catch((error) => {
    //           console.error("Error fetching watches:", error);
    //           this.setState({ loaded: true });
    //         });
    //       } else {
    //         // this.props.fetchBrowseWatches(); // frequent error recived in the console
    //       }
    //     } catch (error) {
    //       console.log(error);
    //     }
    //     //this.props.dialColor();
    //     this.checkboxval();
    //   } else {
    //     window.location.href = "/login";
    //   }
    // }
    //this.props.inventoryDetailById( this.state.UserId);
  }

  SearchInventoryWatchesdetails(userObject = null) {
    const userId = this.state.userData && this.state.userData.userId;
    const id = userId ? userId : userObject ? userObject.userId : null;
    this.setState(
      { loaded: false, pagenumber: 1, selectedItems: [], isDeleteAll: false, hasMore: false, loadingMore: false, },
      () => {
        let keySearch = this.state.key;
        let searchData = "";
        if (keySearch) {
          searchData = keySearch.replace(/[&\/\\,+!@^&()$~%.'":;-?<>{}]/g, "");
          searchData = searchData.replaceAll("-", "");
          searchData = searchData.trim();
        }
        let data = {
          userid: this.state.userData.userId,
          roleid: this.state.userData.roleId,
          brand_id: this.state.brand_id,
          brand_name: this.state.brand_description,
          key: searchData,
          // is_notsale: this.state.notforSale.toString(),
          invoicestatus: this.state.paidStatus,
          sold: this.state.soldStatus,
          dial_color: this.state.DialColor,
          location_id: this.state.locationSearch?.id,
          contactname: this.state.contactName
            ? this.state.contactName.replace(/\s+/g, "")
            : "",
          contacttype: this.state.contactType,
          // inventory_status: this.state.inventoryStatus,
          inventoryxlid: this.normalizeInventoryXlId(this.state.inventoryxlid),
          inventory_type: this.state.InventoryType,
          inventory_status: this.state.InventoryStatus,
          purchace_date:
            this.state.purchasedate === 0
              ? "ALL"
              : this.state.purchasedate > 180
                ? "UNKNOWN"
                : this.state.purchasedate,
          type: this.state.type,
          category: this.state.InventoryCategory,
          product_image: this.state.productImage,
        };
        if (data.type === "ALL") {
          delete data.type;
        }
        if (data.category == "ALL") {
          delete data.category;
        }
        if (
          data.brand_id !== "" ||
          data.key !== "" ||
          data.sold !== "" ||
          data.inventoryxlid !== "" ||
          data.inventory_type !== "" ||
          data.inventory_status !== "" ||
          data.purchace_date !== "" ||
          data.type !== "ALL" ||
          data.category !== "ALL" ||
          data.product_image !== "ALL"
        ) {
          this.setState({ searchEnabled: true });
        }
        if (data.brand_id === "ALL") {
          delete data.brand_id;
          delete data.brand_name;
        }
        if (data.sold === "") {
          data.sold = "ALL";
        }
        data["priceRange"] = {
          min: this.state.priceRange[0],
          max:
            this.state.priceRange[1] > 100000 ? null : this.state.priceRange[1],
        };
        if (data.priceRange.min == 0 && data.priceRange.max == null) {
          delete data.priceRange;
        }
        // const inventoryDetails = this.props.SearchInventoryWatches(data, this.state.currentUser.userId);
        searchinventry
          .addinvetrysearchdataa(
            data,
            this.state.accountId,
            this.state.pagecontent,
            this.state.pagenumber,
          )
          .then((res) => {
            if (res.data && res.data.inventoryData) {
              this.setState({
                inventoryData: res.data.inventoryData,
                page: 0,
                loaded: true,
              });
            } else {
              this.setState({ inventoryData: [], page: 0, loaded: true });
            }
            if (res.data.success === 1) {
              this.setState((prevState) => ({
                updatedInvenentryList: res.data.data,
                updateIntiate: true,
                loaded: true,
                noItemFound:
                  res.data.data?.length === 0 ? "No More Items Left" : null,
                hasMore: (res.data.data?.length || 0) >= prevState.pagecontent,
                loadingMore: false,
                noOfItemsInventory: res.data?.totalInventory ?? 0,
                totalCostforInventory: res.data?.totalCost ?? 0,
              }));
            } else if (res.data.success === 0) {
              this.setState({
                updatedInvenentryList: [],
                updateIntiate: false,
                errorMessage: res.data.message,
                loaded: true,
                // noItemFound: res.data?.data?.length === 0 ? "Error" : null
              });
            } else {
              this.setState({
                errorMessage: res.message,
                loaded: true,
                // noItemFound: res.data?.data?.length === 0 ? "Error" : null
              });
            }
          });
      },
    );
  }

  fetchMoreData = (inventoryList) => {
    let scrollTop = document.documentElement.scrollHeight;
    if (scrollTop < 800) return;

    this.setState({ loadingMore: true }, () => {
      this.setState(
        (prevState) => ({
          pagenumber: prevState.pagenumber + 1,
        }),
        () => {
          const { pagenumber, pagecontent } = this.state;
          this.setState({ isDeleteAll: false, selectAll: false });
          let keySearch = this.state.key;
          let searchData = "";
          if (keySearch) {
            searchData = keySearch.replace(
              /[&\/\\,+!@^&()$~%.'":;-?<>{}]/g,
              "",
            );
            searchData = searchData.replaceAll("-", "");
            searchData = searchData.trim();
          }
          let data = {
            brand_id: this.state.brand_id,
            roleid: this.state.userData.roleId,
            brand_name: this.state.brand_description,
            key: searchData,
            // is_notsale: this.state.notforSale.toString(),
            invoicestatus: this.state.paidStatus,
            sold: this.state.soldStatus,
            dial_color: this.state.DialColor,
            location_id: this.state.locationSearch?.id,
            contactname: this.state.contactName
              ? this.state.contactName.replace(/\s+/g, "")
              : "",
            contacttype: this.state.contactType,
            // inventory_status: this.state.inventoryStatus,
            inventoryxlid: this.normalizeInventoryXlId(this.state.inventoryxlid),
            inventory_type: this.state.InventoryType,
            inventory_status: this.state.InventoryStatus,
            purchace_date:
              this.state.purchasedate === 0
                ? "ALL"
                : this.state.purchasedate > 180
                  ? "UNKNOWN"
                  : this.state.purchasedate,
            type: this.state.type,
            category: this.state.InventoryCategory,
            product_image: this.state.productImage,
          };
          if (data.brand_id === "ALL") {
            delete data.brand_id;
            delete data.brand_name;
          }
          if (data.type === "ALL") {
            delete data.type;
          }
          if (data.category === "ALL") {
            delete data.category;
          }
          if (
            data.brand_id !== "" ||
            data.key !== "" ||
            data.sold !== "" ||
            data.inventoryxlid !== "" ||
            data.inventory_type !== "" ||
            data.inventory_status !== "" ||
            data.purchace_date !== "" ||
            data.type !== "ALL" ||
            data.category !== "ALL" ||
            data.product_image !== "ALL"
          ) {
            this.setState({ searchEnabled: true });
          }
          if (data.sold === "") {
            data.sold = "ALL";
          }
          data["priceRange"] = {
            min: this.state.priceRange[0],
            max:
              this.state.priceRange[1] > 100000
                ? null
                : this.state.priceRange[1],
          };
          if (data.priceRange.min == 0 && data.priceRange.max == null) {
            delete data.priceRange;
          }
          searchinventry
            .addinvetrysearchdataa(
              data,
              this.state?.accountId,
              pagecontent,
              pagenumber,
            )
            .then((res) => {
              if (res.data && res.data.inventoryData) {
                this.setState({
                  inventoryData: res.data.inventoryData,
                  page: 0,
                });
              } else {
                this.setState({ inventoryData: [], page: 0 });
              }
              if (res.data.success === 1) {
                this.setState((prevState) => ({
                  updatedInvenentryList: [...inventoryList, ...res.data.data],
                  updateIntiate: true,
                  noItemFound:
                    res.data.data?.length === 0 ? "No More Items Left" : null,
                  hasMore: (res.data.data?.length || 0) >= prevState.pagecontent,
                  loadingMore: false,
                }));
              } else if (res.data.success === 0) {
                this.setState({
                  updatedInvenentryList: [],
                  updateIntiate: false,
                  errorMessage: res.data.message,
                  hasMore: false,
                  loadingMore: false,
                  // noItemFound: res.data?.data?.length === 0 ? "Error" : null
                });
              } else {
                this.setState({
                  errorMessage: res.message,
                  hasMore: false,
                  loadingMore: false,
                  // noItemFound: res.data?.data?.length === 0 ? "Error" : null
                });
              }
            })
            .catch(() => {
              this.setState({ hasMore: false, loadingMore: false });
            });
        },
      );
    });
  };

  showDropdownMenu(event) {
    event.preventDefault();
    this.setState({ openDropDown: true }, () => {
      document.addEventListener("click", this.hideDropdownMenu);
    });
  }

  hideDropdownMenu() {
    this.setState({ openDropDown: false }, () => {
      document.removeEventListener("click", this.hideDropdownMenu);
    });
  }

  handleClick(event, row) {
    // this.setState({anchorE2: event.currentTarget});
  }

  checkboxval(input) {
    const id = input?.id;
    const sold = input?.sold;
    if (
      this.props.InventoryList &&
      this.props.InventoryList.data &&
      this.props.InventoryList.data.length > 0 &&
      id
    ) {
      const inventoryList = this.props.InventoryList.data;
      const indexPosition = inventoryList.findIndex((singleInventory) => {
        if (singleInventory.inventoryid === id) {
          return singleInventory;
        }
      });
      if (indexPosition > -1) {
        if (sold === true) {
          this.props.InventoryList.data[indexPosition].sold = 1;
        } else {
          this.props.InventoryList.data[indexPosition].sold = 0;
        }
      }
    } else if (
      this.props.InventoryList &&
      this.props.InventoryList.data &&
      this.props.InventoryList.data.length > 0
    ) {
      for (let i = 0; i < this.props.InventoryList.data.length; i++) {
        if (this.props.InventoryList.data[i].sold == 1) {
          this.setState({ soldbtn: true });
        } else {
          this.setState({ soldbtn: false });
        }
      }
    }
    if (id && this.state.updatedInvenentryList) {
      let inventoryList = this.state.updatedInvenentryList;
      const indexPosition = inventoryList.findIndex((singleInventory) => {
        if (singleInventory.inventoryid === id) {
          return singleInventory;
        }
      });
      if (indexPosition > -1) {
        if (sold === true) {
          inventoryList[indexPosition].sold = 1;
        } else {
          inventoryList[indexPosition].sold = 0;
        }
        this.setState({
          updatedInvenentryList: inventoryList,
          updateIntiate: true,
        });
      }
      // if (inventoryList && inventoryList.length > 0) {
      //   for (let i = 0; i < inventoryList.length; i++) {
      //     if (id && inventoryList[i].inventoryid === id) {
      //       if (sold === true) {
      //         inventoryList[i].sold = 1;
      //       } else {
      //         inventoryList[i].sold = 0;
      //       }
      //       this.setState({ updatedInvenentryList: inventoryList });
      //     }
      //   }
      // }
    }
  }

  async componentWillReceiveProps(newProps) {
    const { pagecontent, pagenumber } = this.state;
    if (newProps.currentUser && !this.state.currentUser) {
      this.setState({
        ...this.state,
        currentUser: newProps.currentUser,
      });
      let keySearch = this.state.key;
      let searchData = "";
      if (keySearch) {
        searchData = keySearch.replace(/[&\/\\,+!@^&()$~%.'":;-?<>{}]/g, "");
        searchData = searchData.replaceAll("-", "");
        searchData = searchData.trim();
      }
      // const data = {
      //   key: searchData,
      //   dial_color: this.state.DialColor,
      //   location_id: this.state.locationSearch?.id,
      //   contactname: this.state.contactName,
      //   contacttype: this.state.contactType,
      //   userid: this.state.userData.userId,
      //   brand_id: this.state.brand_id,
      //   brand_name: this.state.brand_description,
      //   sold: this.state.soldStatus,
      //   // is_notsale:this.state.notforSale.toString(),
      //   invoicestatus: this.state.paidStatus == '' ? "ALL" : this.state.paidStatus,
      //   // inventory_status: this.state.inventoryStatus,
      //   inventoryxlid: this.normalizeInventoryXlId(this.state.inventoryxlid),
      //   inventory_type: this.state.InventoryType,
      //   inventory_status: this.state.InventoryStatus,
      //   purchace_date:
      //     this.state.purchasedate === 0
      //       ? "ALL"
      //       : this.state.purchasedate > 180
      //         ? "UNKNOWN"
      //         : this.state.purchasedate,
      //   type: this.state.type,
      //   category: this.state.InventoryCategory,
      //   product_image: this.state.productImage
      // };
      // if (data.type === "ALL") {
      //   delete data.type
      // }
      // if (data.category === "ALL") {
      //   delete data.category
      // }
      // await this.props.fetchInventoryWatches(this.state?.accountId, data, pagecontent, pagenumber);
      // this.setState({
      //   totalCostforInventory: this.props.InventoryList?.totalCost,
      //   noOfItemsInventory: this.props.InventoryList?.totalInventory,
      //   noItemFound: this.props.InventoryList?.data?.length === 0 ? "No data found" : null,
      //   loaded: true
      // });
      this.props.fetchInventoryExcelList(newProps.currentUser.userId);
      //this.props.inventoryDetailById(newProps.currentUser.inventoryid);
      const bulkUploadId = this.props?.match?.params.bulkUploadId || null;
      if (bulkUploadId) {
        this.SearchInventoryWatchesdetails(newProps.currentUser);
      }
    }
  }

  handleChangeOfBrandByBrandName = (event) => {
    const brandId = event.target.value;
    if (brandId === "ALL") {
      this.setState({
        brand_id: "ALL",
        BrandName: "",
        brand_description: "",
        modledata: "",
        appliedFilterName: "",
      });
    } else {
      const selectedBrand = this.props.brandInfo.data.find(
        (brand) => brand.brandid === brandId,
      );

      this.setState({
        brand_id: selectedBrand.brandid,
        brand_description: selectedBrand.brandname,
        BrandName: selectedBrand.brandid,
        modledata: selectedBrand.brandname,
        appliedFilterName: "",
      });
    }

    setTimeout(() => {
      this.SearchInventoryWatchesdetails();
    }, 1000);
  };

  valueLabelFormat = (value) => {
    let scaledValue = value;
    if (value === "0") {
      scaledValue = "ALL";
    } else if (value > 180) {
      scaledValue = "UNKNOWN";
    } else {
      scaledValue = value;
    }
    return `${scaledValue}`;
  };

  valuePriceRangeFormat = (value) => {
    let scaledValue = value;
    if (value === "0") {
      scaledValue = "0";
    } else if (value > 120000) {
      scaledValue = "UNKNOWN";
    } else {
      scaledValue = value;
    }
    return `${scaledValue}`;
  };

  inventoryPurchaseDateInterval = (value) => {
    let purchase = value;
    // let purchaseDate = "";
    // if (purchase === "ALL") {
    //     purchaseDate = "0";
    // } else {
    //     purchaseDate = purchase;
    // }
    this.setState({
      purchasedate: purchase,
      appliedFilterName: "",
    });
    // setTimeout(() => {
    //     this.SearchInventoryWatchesdetails();
    // }, 1000);
  };

  inventoryPriceRangeInterval = (value) => {
    let range = value;
    this.setState({
      priceRange: range,
      appliedFilterName: "",
    });
  };

  normalizeInventoryXlId(id) {
    if (!id) return "";
    if (id === "ALL") return "ALL";
    return id;
  }

  handleChangeOfBulkUploadId(event) {
    this.setState({
      inventoryxlid: event.target.value,
      appliedFilterName: "",
    });
    setTimeout(() => {
      this.SearchInventoryWatchesdetails();
    }, 1000);
    // window.open("/myinventory/" + event.target.value)
  }

  handleClose(option) {
    this.setState({ open: false });
    window.open("/create/invoice");
  }
  handleOpenGenerateLabelDialog = () => {
    this.setState({
      openGenerateLabelDialog: true,
      selectedLeftFields: [...this.state.lastSelectedLeftFields],
      selectedRightFields: [...this.state.lastSelectedRightFields],
    });
  };

  handleCloseGenerateLabelDialog = () => {
    this.setState({
      openGenerateLabelDialog: false,
      // selectedLeftFields: [],
      // selectedRightFields: [],
      startRow: "",
      quantity: "",
      selectedFile: null,
    });
  };
  handleLabelFieldChange = (event, side) => {
    const { value, checked } = event.target;
    const fieldId = value.split("-")[1];

    this.setState((prevState) => {
      const selectedKey =
        side === "left" ? "selectedLeftFields" : "selectedRightFields";
      const currentList = prevState[selectedKey] || [];

      if (checked && currentList.length >= 2) {
        if (!this.toastLock) {
          this.toastLock = true;
          toast.error(
            `You can select only up to 2 fields on the ${side} side.`,
          );
          setTimeout(() => {
            this.toastLock = false;
          }, 900);
        }
        return null;
      }

      const updatedList = checked
        ? [...currentList, fieldId]
        : currentList.filter((id) => id !== fieldId);

      return {
        [selectedKey]: updatedList,
      };
    });
  };

  handleGenerateLabel = () => {
    const {
      selectedLeftFields,
      selectedRightFields,
      startRow,
      selectedItems,
      selectAll,
      accountId,
      userData,
      brand_id,
      brand_description,
      InventoryCategory,
      contactName,
      contactType,
      DialColor,
      paidStatus,
      InventoryStatus,
      InventoryType,
      inventoryxlid,
      purchasedate,
      type,
      soldStatus,
      productImage,
      key,
      quantity,
    } = this.state;

    const startingRow = parseInt(startRow, 10) || 1;

    if (!selectAll && (!selectedItems || selectedItems.length === 0)) {
      toast.error("Please select at least one inventory item.");
      return;
    }

    const inventoryIds = Array.isArray(selectedItems)
      ? selectedItems
      : [selectedItems];

    const payload = selectAll
      ? {
        accountId,
        brand_id,
        brand_name: brand_description,
        category: InventoryCategory,
        contactname: contactName,
        contacttype: contactType,
        dial_color: DialColor,
        fileType: "PDF",
        inventory_status: InventoryStatus,
        inventory_type: InventoryType,
        inventoryxlid: this.normalizeInventoryXlId(inventoryxlid),
        invoicestatus: paidStatus,
        key,
        product_image: productImage,
        purchace_date:
          purchasedate === 0
            ? "ALL"
            : purchasedate > 180
              ? "UNKNOWN"
              : purchasedate,
        sold: soldStatus || "0",
        type: type || "standard_watch",
        userid: userData.userId,
        leftCols: selectedLeftFields,
        rightCols: selectedRightFields,
        startingRow,
        quantity,
      }
      : {
        inventoryIds,
        leftCols: selectedLeftFields,
        rightCols: selectedRightFields,
        startingRow,
        quantity,
      };

    generateLabelPDFRequest(payload, (err, response) => {
      if (err) {
        toast.error("Failed to generate PDF");
        console.error("PDF generation error:", err);
        return;
      }
      this.setState({
        lastSelectedLeftFields: [...this.state.selectedLeftFields],
        lastSelectedRightFields: [...this.state.selectedRightFields],
      });
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);

      let fileName = `labels-${Date.now()}.pdf`;
      const contentDisposition = response.headers["content-disposition"];
      if (contentDisposition && contentDisposition.includes("filename=")) {
        const matches = contentDisposition.match(
          /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
        );
        if (matches && matches[1]) {
          fileName = matches[1].replace(/['"]/g, "").trim();
        }
      }

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      this.setState(
        {
          openGenerateLabelDialog: false,
          // selectedLeftFields: [],
          // selectedRightFields: [],
          startRow: "",
          quantity: "",
          selectedFile: null,
          selectAll: false,
          selectedItems: [],
        },
        () => {
          this.props.history.push("/myinventory");
          setTimeout(() => window.scrollTo(0, 0), 50);
          toast.success(`PDF Downloaded Successfully!`);
        },
      );
    });
  };

  removeSoldUnsold() {
    this.setState({
      soldStatus: "",
      searchEnabled: false,
    });
    setTimeout(() => {
      this.SearchInventoryWatchesdetails();
    }, 1000);
    // setTimeout(() => {
    //   this.setState({ loaded: true });
    // }, 1000);
    // this.props.fetchInventoryExcelList(this.state.currentUser.userId);
    // this.props.fetchInventoryWatches(this.state.userData?.accountId);
  }

  removePaidStatus() {
    this.setState({
      paidStatus: "",
      searchEnabled: false,
    });
    setTimeout(() => {
      this.SearchInventoryWatchesdetails();
    }, 1000);
    // setTimeout(() => {
    //   this.setState({ loaded: true });
    // }, 1000);
    // this.props.fetchInventoryExcelList(this.state.currentUser.userId);
    // this.props.fetchInventoryWatches(this.state.userData?.accountId);
  }

  removeInventoryStatus() {
    this.setState({
      inventoryStatus: "",
      InventoryStatus: "",
      searchEnabled: false,
    });
    setTimeout(() => {
      this.SearchInventoryWatchesdetails();
    }, 1000);
    // setTimeout(() => {
    //   this.setState({ loaded: true });
    // }, 1000);
    // this.props.fetchInventoryExcelList(this.state.currentUser.userId);
    // this.props.fetchInventoryWatches(this.state.userData?.accountId);
  }

  removeBulkUploadId() {
    this.setState({
      inventoryxlid: "",
      searchEnabled: false,
    });
    setTimeout(() => {
      this.SearchInventoryWatchesdetails();
    }, 1000);
    // setTimeout(() => {
    //   this.setState({ loaded: true });
    // }, 1000);
    // this.props.fetchInventoryExcelList(this.state.currentUser.userId);
    // this.props.fetchInventoryWatches(this.state.userData?.accountId);
  }

  removeInventoryType() {
    this.setState({
      InventoryType: "",
      searchEnabled: false,
    });
    setTimeout(() => {
      this.SearchInventoryWatchesdetails();
    }, 1000);
    // setTimeout(() => {
    //   this.setState({ loaded: true });
    // }, 1000);
    // this.props.fetchInventoryExcelList(this.state.currentUser.userId);
    // this.props.fetchInventoryWatches(this.state.userData?.accountId);
  }

  removeImageType = () => {
    this.setState({
      productImage: "",
      searchEnabled: false,
    });
    setTimeout(() => {
      this.SearchInventoryWatchesdetails();
    }, 1000);
    // setTimeout(() => {
    //   this.setState({ loaded: true });
    // }, 1000);
    // this.props.fetchInventoryExcelList(this.state.currentUser.userId);
    // this.props.fetchInventoryWatches(this.state.userData?.accountId);
  };

  // removeInventoryStatus() {
  //   this.setState({
  //     InventoryStatus: "",
  //     searchEnabled: false,
  //   });
  //   setTimeout(() => {
  //     this.SearchInventoryWatchesdetails();
  //   }, 1000);
  //   // setTimeout(() => {
  //   //   this.setState({ loaded: true });
  //   // }, 1000);
  //   // this.props.fetchInventoryExcelList(this.state.currentUser.userId);
  //   // this.props.fetchInventoryWatches(this.state.userData?.accountId);
  // }

  removetype() {
    this.setState({
      type: "",
      searchEnabled: false,
    });
    setTimeout(() => {
      this.SearchInventoryWatchesdetails();
    }, 1000);
    // setTimeout(() => {
    //   this.setState({ loaded: true });
    // }, 1000);
    // this.props.fetchInventoryExcelList(this.state.currentUser.userId);
    // this.props.fetchInventoryWatches(this.state.userData?.accountId);
  }

  removeInventoryCategory() {
    this.setState({
      InventoryCategory: "",
      searchEnabled: false,
    });
    setTimeout(() => {
      this.SearchInventoryWatchesdetails();
    }, 1000);
    // setTimeout(() => {
    //   this.setState({ loaded: true });
    // }, 1000);
    // this.props.fetchInventoryExcelList(this.state.currentUser.userId);
    // this.props.fetchInventoryWatches(this.state.userData?.accountId);
  }

  removebrandname() {
    // var element = document.getElementsByClassName("brandClass")[0];
    // element.classList.remove("MuiInputLabel-shrink");
    //  $('.brandLangend .PrivateNotchedOutline-legendLabelled-87 > span').css('display','none')
    this.props.brandList();
    this.setState({
      modledata: "",
      removedbrndname: "",
      searchEnabled: false,
      brand_id: "",
      brand_description: "",
      BrandName: "",
      loaded: false,
      // band_material: this.state.CaseMaterial,
      // case_size: this.state.CafetchInventoryWatchesseSize,
      // case_material: this.state.case_material,
      page_no: "1",
      limit: "12",
    });
    // setTimeout(() => {
    //   this.setState({ loaded: true });

    // }, 1000);
    setTimeout(() => {
      this.SearchInventoryWatchesdetails();
    }, 1000);
    // this.props.fetchInventoryExcelList(this.state.currentUser.userId);
    // this.props.fetchInventoryWatches(this.state.userData?.accountId);
    // let data = {
    //     "brand_id": "",
    // "band_material": this.state.CaseMaterial,
    // "case_size": this.state.CaseSize,
    // "case_material": this.state.case_material,
    //     "page_no": "1",
    //     "limit": "100",
    // }
    // searchApi.productSeach(data, this.state.producId).then((res) => {
    //     this.setState({
    //         browseWatchesInfo: res.data.data
    //     })
    //     if (res.data.success === 1) {
    //         this.setState({
    //             browseWatchesInfo: res.data.data
    //         })
    //     } else {
    //         this.setState({
    //             errorMessage: res.message
    //         })
    //     }

    // })
  }

  handleChangeOfInventoryDetailById = (id, invoiceId) => {
    const { history } = this.props;
    // window.open("/inventory-detail/" + id + "/" + this.state.currentUser.userId);
    if (this.state.userData.userId) {
      this.props.history.push(
        "/inventory-detail/" + id + "/" + this.state.userData.userId,
        {
          inventoryCacheState: { ...this.state },
        },
      );
    }
    localStorage.setItem("invoiceId", invoiceId);
    {
      this.props.inventoryDetailById(id);
    }
  };

  renderShopifySyncLoader() {
    if (!this.state.shopifySyncLoading && !this.state.ebaySyncLoading) return null;
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "rgb(57 54 54 / 60%)",
          // opacity: 0.7,
          zIndex: 2000,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <CircularProgress color="inherit" style={{ width: 50, height: 50 }} />
          {/* <SpinnerRoundFilled size={80} thickness={100} color="#1976d2" /> */}
          <div style={{ marginTop: 12 }}>
            <Typography variant="h6">Syncing the inventories...</Typography>
          </div>
        </div>
      </div>
    );
  }

  browseWatches() {
    this.setState({
      nonsearchstring: false,
    });
    this.props.fetchSearchBrowseWatches(this.state.searchString);
    // if (this.state.selected.product && this.state.selected.product.model) {
    //   // this.props.history.push(
    //   //   "/browsewatches/" + this.state.selected.product.model
    //   // );
    //   this.props.fetchSearchBrowseWatches(this.props.match.params.productId);
    // }
  }

  onProductChange = _.debounce((e, v, r) => {
    // this.props.onTextInputAdd(text);
    if (v) {
      switch (e) {
        case "product_selected":
          this.setState({
            ...this.state,
            selected: { product: v },
          });
          // this.props.history.push('/browsewatches/' + v.model)
          break;
        case "input_changed":
          this.state.autocomplete.currentInput = v;

          this.state.autocomplete.loading = true;
          this.setState({
            ...this.state,
          });
          if (v.length >= 3 && r == "input") {
            this.props.searchProducts({ searchText: v }, (error, res) => { });
          }
          break;
      }
    } else {
    }
  }, 600);

  onChangeOfFirstName = (event) => {
    this.setState({
      key: event.target.value,
    });
  };

  autocomplete(evt) {
    let text = evt.target.value;
    this.setState({ searchString: text });
    this.setState({ loading: true });
    this.getAutocomplete(text);
  }

  getAutocomplete = (evt) => {
    // const inventoryList = this.props.InventoryList.data;s
    // this.props.searchProducts({ searchText: evt }, (error, res) => {
    //     this.setState({ searchItems: this.state.autocomplete.data });
    //     this.setState({ loading: false });
    // });
  };

  hanldeKeyup(evt) {
    //if (evt.keyCode === 27) {
    //  this.setState({ searchItems: [] });
    //   return false;
    //  }
  }

  hanldeKeydown(evt) {
    /*
        const { cursor, searchItems } = this.state;
        // arrow up/down button should select next/previous list element
        if (evt.keyCode === 38 && cursor > 0) {
          this.setState((prevState) => ({
            cursor: prevState.cursor - 1,
          }));
        } else if (evt.keyCode === 40 && cursor < searchItems.length - 1) {
          this.setState((prevState) => ({
            cursor: prevState.cursor + 1,
          }));
        }
        if (evt.keyCode === 13) {
          let currentItem = searchItems[cursor];
          if (currentItem !== undefined) {
            const { name, code, rate, unit } = currentItem;
            this.setState({ item: { name, code, rate, unit }, searchItems: [] });
          }
        }
        if (evt.keyCode === 8) {
          this.setState({ item: { name: "", code: "", rate: "", unit: "" } });
        }*/
  }

  selectItem(id) {
    const { searchItems } = this.state;
    let selectedItem = searchItems.find((item) => item.model === id);
    // const { code, name, unit, rate } = selectedItem;
    //  this.setState({ item: {  name, unit, rate } });
    this.setState({ searchString: selectedItem.searchattr });
    this.setState({ searchStringdetails: selectedItem.searchattr });
    this.setState({ autocomplete: { data: [] } });
    // this.props.fetchSearchBrowseWatches(id);
  }

  handleListKeydown(evt) { }

  handleChange(evt) {
    this.setState({ item: { [evt.target.name]: evt.target.value } });
  }

  downloadInventory(type) {
    const userId = this.state.userData && this.state.userData.userId;
    const id = userId ? userId : null;
    this.setState({ downloadloading: true });
    let keySearch = this.state.key;
    let searchData = "";
    if (keySearch) {
      searchData = keySearch.replace(/[&\/\\#,+!@^&()$~%.'":;-?<>{}]/g, "");
      searchData = searchData.replaceAll("-", "");
      searchData = searchData.trim();
    }
    // let data = {
    //   brand_id: this.state.brand_id,
    //   brand_name: this.state.brand_description,
    //   key: searchData,
    //   sold: this.state.soldStatus === "" ? "ALL" : this.state.soldStatus,
    //   // inventory_status: this.state.inventoryStatus,
    //   inventoryxlid: this.normalizeInventoryXlId(this.state.inventoryxlid),
    //   inventory_type: this.state.InventoryType,
    //   inventory_status: this.state.InventoryStatus,
    //   purchasedate:
    //     this.state.purchasedate === 0
    //       ? "ALL"
    //       : this.state.purchasedate > 180
    //         ? "UNKNOWN"
    //         : this.state.purchasedate,
    //   userid: id,
    //   accountid: this.state.accountId ? this.state.accountId : null,
    //   type: this.state.type === "" ? "ALL" : this.state.type,
    //   category: this.state.InventoryCategory,
    //   fileType: type
    // };
    let data = {
      accountid: this.state.accountId ? this.state.accountId : null,
      userid: this.state.userData.userId,
      brand_id: this.state.brand_id,
      brand_name: this.state.brand_description,
      key: searchData,
      sold: this.state.soldStatus === "" ? "ALL" : this.state.soldStatus,
      invoicestatus: this.state.paidStatus,
      dial_color: this.state.DialColor,
      location_id: this.state.locationSearch?.id,
      contactname: this.state.contactName
        ? this.state.contactName.replace(/\s+/g, "")
        : "",
      contacttype: this.state.contactType,
      inventoryxlid: this.normalizeInventoryXlId(this.state.inventoryxlid),
      inventory_type: this.state.InventoryType,
      inventory_status: this.state.InventoryStatus,
      purchace_date:
        this.state.purchasedate === 0
          ? "ALL"
          : this.state.purchasedate > 180
            ? "UNKNOWN"
            : this.state.purchasedate,
      type: this.state.type,
      category: this.state.InventoryCategory,
      product_image: this.state.productImage,
      fileType: type,
    };
    if (data.type === "ALL") {
      delete data.type;
    }
    if (data.category === "ALL") {
      delete data.category;
    }
    if (data.sold === "") {
      data.sold = "ALL";
    }
    data["priceRange"] = {
      min: this.state.priceRange[0],
      max: this.state.priceRange[1] > 100000 ? null : this.state.priceRange[1],
    };
    if (data.priceRange.min == 0 && data.priceRange.max == null) {
      delete data.priceRange;
    }
    // const inventoryDetails = this.props.SearchInventoryWatches(data, this.state.currentUser.userId);
    searchinventry.downloadInventory(data, id).then((res) => {
      if (res && res.status === 0) {
        toast("No Inventories for download.", {
          autoClose: 5000,
          type: toast.TYPE.SUCCESS,
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
      this.setState({ downloadloading: false });
    });
  }

  handleSwitch = (row, event) => {
    const id = row.inventoryid;
    const checkstaus = event.target.checked;
    this.setState({
      rowDetails: row,
    });
    if (checkstaus === true) {
      this.setState({
        soldbtn: true,
        disable: true,
      });
      localStorage.setItem("sold_status", "1");
      localStorage.setItem("inventory_id", id);
      this.checkboxval({ id: id, sold: true });
      this.setState({ soldbtn: true });
    } else {
      this.setState({ soldbtn: false });
      localStorage.setItem("sold_status", "0");
      localStorage.setItem("inventory_id", id);
      this.checkboxval({ id: id, sold: false });
      this.setState({ soldbtn: false });
    }
    this.setState({
      openReasonChange: true,
    });
  };

  getLocationAutocomplete = (evt) => {
    searchLocation({ locationSearch: null }, (error, res) => {
      if (res?.success == 1) {
        this.setState({ locationAutoCompleteData: res?.data });
      }
    });
  };

  handleCloseOfReasonChange() {
    const id = this.state.rowDetails.inventoryid;
    let sold = this.state.rowDetails.sold;
    if (sold == 0) {
      this.checkboxval({ id: id, sold: true });
    } else {
      this.checkboxval({ id: id, sold: false });
    }
    this.setState({
      openReasonChange: false,
    });
  }

  copyToClipboard = async (token = null) => {
    const userDetails = window.sessionStorage.getItem("userDetails")
      ? JSON.parse(window.sessionStorage.getItem("userDetails"))
      : null;
    let companyName = userDetails?.accountName?.replace(/[\s.]/g, "");
    const baseURL = `${constants.SHARE_INVENTORY}dealerfeed/${companyName}`;
    const copyText = token ? `${baseURL}?token=${token}` : baseURL;
    alert(copyText);
    try {
      await copy(copyText);
      toast.success("Copied to Clipboard");
    } catch {
      toast.error("Not copied");
    }
    //const isCopy=await navigator.clipboard.writeText(copyText)
    // if (isCopy) {
    //   toast.success("Copied to Clipboard");
    // }
  };

  changeRangeName = (reason) => {
    // const id = row.inventoryid;
    // const { productid, serialno } = row;
    const id = this.state.rowDetails.inventoryid;
    const { productid, serialno, invoiceid } = this.state.rowDetails;
    let data = {
      inventory_id: localStorage.getItem("inventory_id"),
      sold_status: localStorage.getItem("sold_status"),
      productId: productid,
      serialNumer: serialno,
      listed_on: this.state.listed_on,
      sold_unsold_reason: reason,
      invoiceid: invoiceid ? invoiceid : null,
    };
    searchinventry.productsold(data).then((res) => {
      if (res.data.success === 1) {
        this.setState({
          openReasonChange: false,
        });
        toast(res.data.message, {
          autoClose: 5000,
          type: toast.TYPE.SUCCESS,
          position: toast.POSITION.BOTTOM_CENTER,
        });
        this.SearchInventoryWatchesdetails();
        localStorage.removeItem("inventory_id");
        localStorage.removeItem("sold_status");
      } else {
        this.setState({
          openReasonChange: false,
        });
        this.handleCloseOfReasonChange();
        localStorage.removeItem("inventory_id");
        localStorage.removeItem("sold_status");
        toast(res.data.message, {
          autoClose: 5000,
          type: toast.TYPE.ERROR,
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    });
  };

  // copy = () => {
  //   const el = document.createElement(
  //     "https://api.watchops.com/inventories/{this.props.currentUser.userId}/c24-importer.xml"
  //   );
  //   el.value = window.location.href;
  //   document.body.appendChild(el);
  //   el.select();
  //   document.execCommand("copy");
  //   document.body.removeChild(el);
  //   this.setState({
  //     setCopied: true,
  //   });
  // };

  handleChangeOfSoldUnSold(event) {
    let brand = event.target.value;
    this.setState({
      soldStatus: brand,
      appliedFilterName: "",
      selectedItems: [],
      selectAll: false,
    });
    setTimeout(() => {
      this.SearchInventoryWatchesdetails();
    }, 1000);
  }

  handleChangeOfPaidStatus(event) {
    let paid = event.target.value;
    this.setState({
      paidStatus: paid,
      appliedFilterName: "",
    });
    setTimeout(() => {
      this.SearchInventoryWatchesdetails();
    }, 1000);
  }

  handleNotforSaleCheck = (event) => {
    this.setState({
      notforSale: event.target.checked,
    });
    setTimeout(() => {
      this.SearchInventoryWatchesdetails();
    }, 1000);
  };

  handleChangeOfDialColor(event) {
    let dialvalue = event.target.value;
    this.setState({
      DialColor: dialvalue,
    });
  }

  handleEnterEvent(event) {
    if (event.key == "Enter") {
      this.setState({ appliedFilterName: "" });
      this.SearchInventoryWatchesdetails();
    }
  }

  handleChangeOfInventoryStatus(event) {
    let status = event.target.value;
    this.setState({
      inventoryStatus: status,
    });

    setTimeout(() => {
      this.SearchInventoryWatchesdetails();
    }, 1000);
  }

  handleChangePage = (event, newpage) => {
    this.setState({ page: newpage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value });
    this.setState({ page: 0 });
  };

  handleClearButton = () => {
    this.setState({
      key: "",
    });
    setTimeout(() => {
      this.SearchInventoryWatchesdetails();
    }, 1000);
  };

  handleClearDialbutton = () => {
    this.setState({
      DialColor: "",
    });
    setTimeout(() => {
      this.SearchInventoryWatchesdetails();
    }, 1000);
  };

  handleClearContactbutton = () => {
    this.setState({
      contactName: "",
    });
    setTimeout(() => {
      this.SearchInventoryWatchesdetails();
    }, 1000);
  };

  endAdornment = () => {
    const values = this.state.key;
    if (values) {
      return (
        <InputAdornment position="end">
          <IconButton
            onClick={() => {
              this.handleClearButton();
            }}
            onMouseDown={(e) => {
              e.preventDefault();
            }}
            color="primary"
          >
            <ClearIcon />
          </IconButton>
          <IconButton
            className="primary-bg color-white"
            type="button"
            sx={{ p: "10px" }}
            aria-label="search"
            onClick={this.SearchInventoryWatchesdetails}
          >
            <SearchIcon />
          </IconButton>
        </InputAdornment>
      );
    } else {
      return (
        <InputAdornment position="end">
          <IconButton
            className="primary-bg color-white"
            type="button"
            sx={{ p: "10px" }}
            aria-label="search"
            onClick={this.SearchInventoryWatchesdetails}
          >
            <SearchIcon />
          </IconButton>
        </InputAdornment>
      );
    }
  };

  dialColorAdornment = () => {
    const values = this.state.DialColor;
    if (values) {
      return (
        <InputAdornment position="end">
          <IconButton
            onClick={() => {
              this.handleClearDialbutton();
            }}
            onMouseDown={(e) => {
              e.preventDefault();
            }}
            color="primary"
          >
            <ClearIcon />
          </IconButton>
          <IconButton
            className="primary-bg color-white"
            type="button"
            sx={{ p: "10px" }}
            aria-label="search"
            onClick={this.SearchInventoryWatchesdetails}
          >
            <SearchIcon />
          </IconButton>
        </InputAdornment>
      );
    } else {
      return (
        <InputAdornment position="end">
          <IconButton
            className="primary-bg color-white"
            type="button"
            sx={{ p: "10px" }}
            aria-label="search"
            onClick={this.SearchInventoryWatchesdetails}
          >
            <SearchIcon />
          </IconButton>
        </InputAdornment>
      );
    }
  };

  contactNameAdornment = () => {
    const values = this.state.contactName;
    if (values) {
      return (
        <InputAdornment position="end">
          <IconButton
            onClick={() => {
              this.handleClearContactbutton();
            }}
            onMouseDown={(e) => {
              e.preventDefault();
            }}
            color="primary"
          >
            <ClearIcon />
          </IconButton>
          <IconButton
            className="primary-bg color-white"
            type="button"
            sx={{ p: "10px" }}
            aria-label="search"
            onClick={this.SearchInventoryWatchesdetails}
          >
            <SearchIcon />
          </IconButton>
        </InputAdornment>
      );
    } else {
      return (
        <InputAdornment position="end">
          <IconButton
            className="primary-bg color-white"
            type="button"
            sx={{ p: "10px" }}
            aria-label="search"
            onClick={this.SearchInventoryWatchesdetails}
          >
            <SearchIcon />
          </IconButton>
        </InputAdornment>
      );
    }
  };

  calculateTotalCostforInventory = (inventoryList) => {
    const total = inventoryList?.reduce((total, item) => {
      const itemCost = item?.total_cost ? Number(item.total_cost) : 0;
      return total + (isNaN(itemCost) ? 0 : itemCost);
    }, 0);
    return total.toLocaleString("en-US");
  };

  handleMouseEnter = (id) => {
    this.setState({ hoveredCard: id });
  };

  handleMouseLeave = () => {
    this.setState({ hoveredCard: null });
  };

  handleCheckboxChange = (id) => {
    const { noOfItemsInventory } = this.state;
    this.setState((prevState) => {
      const { selectedItems } = prevState;
      const newSelectedItems = selectedItems.includes(id)
        ? selectedItems.filter((item) => item !== id)
        : [...selectedItems, id];
      const selectAll = newSelectedItems.length == noOfItemsInventory;
      return {
        selectedItems: newSelectedItems,
        selectAll: selectAll,
      };
    });
  };

  handleSelectAllChange = (event, inventoryList) => {
    if (event.target.checked) {
      this.setState({
        selectedItems: inventoryList.map((item) => item.inventoryid),
        selectAll: true,
      });
    } else {
      this.setState({ selectedItems: [], selectAll: false });
    }
  };

  handleOTP = () => {
    let email = this.state.userData?.email;
    if (!email) {
      toast("Email not found, Please login again.", {
        autoClose: 5000,
        type: toast.TYPE.ERROR,
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }
    this.setState({ disabled: true });
    let data = {
      to: email ?? null,
      url: "email-otp/send",
    };
    this.props.recoverPassword(data, (error, res) => {
      if (error) {
        showErrorToast(error);
        this.setState({ disabled: false });
      } else {
        if (res.success == 1) {
          showSuccessToast("OTP Sent");
          this.setState({
            openDeleteModal: false,
            openOtpModel: true,
            disabled: false,
          });
        } else {
          showErrorToast(res.message);
          this.setState({ disabled: false });
        }
      }
    });
  };

  onResendOtp = () => {
    let email = this.state.userData?.email;
    if (!email) {
      toast("Email not found, Please login again.", {
        autoClose: 5000,
        type: toast.TYPE.ERROR,
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }
    let data = {
      to: email ?? null,
      url: "email-otp/send",
    };
    this.props.recoverPassword(data, (error, res) => {
      if (error) {
        showErrorToast(error);
      } else {
        if (res.success == 1) {
          document.getElementById("otp_form").reset();
          // this.setState({ showing: false });
          this.resetTimer();
          showSuccessToast("OTP Sent");
        } else {
          showErrorToast(res.message);
          this.setState({ disabled: false });
        }
      }
    });
  };

  onOtpChange = (event) => {
    let otpVal = validator.isNumeric(event.target.value);
    if (!otpVal) {
      this.setState({
        ...this.state,
        otpErrorText: "Enter Otp",
        isValid: false,
      });
    } else {
      this.setState({
        ...this.state,
        otp: event.target.value,
        otpErrorText: "",
        isValid: true,
      });
    }
  };

  validateInput = () => {
    let otpErrorText = "";
    let isValid = true;
    if (this.state.otp.length === 0) {
      otpErrorText = "Enter OTP";
      isValid = false;
    }
    this.setState({
      ...this.state,
      otpErrorText,
    });
    return isValid;
  };

  handleVerifyOTP = (inventoryList) => {
    let email = this.state.userData?.email;
    if (this.validateInput()) {
      this.setState({ disabled: true });
      let data = {
        otp: this.state.otp,
        to: email ?? null,
        url: "email-otp/verify",
      };
      this.props.verifyOtp(data, (error, res) => {
        if (error) {
          showErrorToast("Invalid OTP");
          this.setState({ disabled: false });
        } else {
          if (res.success) {
            this.handleInventoryDelete(inventoryList);
          } else {
            showErrorToast("Invalid OTP");
            this.setState({ disabled: false });
          }
        }
      });
    }
  };

  handleInventoryDelete = (inventoryList) => {
    let {
      selectedItems,
      userData,
      accountId,
      isDeleteAll,
      key,
      brand_id,
      brand_description,
      paidStatus,
      soldStatus,
      DialColor,
      locationSearch,
      contactName,
      contactType,
      inventoryxlid,
      InventoryType,
      InventoryStatus,
      purchasedate,
      type,
      InventoryCategory,
    } = this.state;
    let data = {};
    if (isDeleteAll) {
      data = {
        accountId: accountId,
        inventoryId: null,
        delete: "ALL",
      };
    } else if (selectedItems.length === inventoryList.length) {
      let searchData = "";
      if (key) {
        searchData = key.replace(/[&\/\\#,+!@^&()$~%.'":;-?<>{}]/g, "");
        searchData = searchData.replaceAll("-", "");
        searchData = searchData.trim();
      }
      data = {
        accountId: accountId,
        filters: {
          brand_id: brand_id,
          brand_name: brand_description,
          key: searchData,
          invoicestatus: paidStatus,
          sold: soldStatus,
          dial_color: DialColor,
          location_id: locationSearch?.id,
          contactname: contactName,
          contacttype: contactType,
          inventoryxlid: this.normalizeInventoryXlId(inventoryxlid),
          inventory_type: InventoryType,
          inventory_status: InventoryStatus,
          purchace_date:
            purchasedate === 0
              ? "ALL"
              : purchasedate > 180
                ? "UNKNOWN"
                : purchasedate,
          type: type,
          category: InventoryCategory,
        },
      };
    } else {
      data = {
        accountId: accountId,
        inventoryId: selectedItems,
        delete: "",
      };
    }
    deleteInventories(data, (error, res) => {
      if (error) {
        showErrorToast(error);
        this.setState({ disabled: false });
      } else {
        if (res.success == 1) {
          this.SearchInventoryWatchesdetails();
          showSuccessToast("Deleted Successfully");
          this.setState({
            openOtpModel: false,
            disabled: false,
            isDeleteAll: false,
          });
        } else {
          showErrorToast(res.message);
          this.setState({ disabled: false });
        }
      }
    });
  };

  sanitizeKey = (key) => {
    if (!key) return "";
    let sanitizedKey = key.replace(/[&\/\\#,+!@^&()$~%.'":;-?<>{}]/g, "");
    return sanitizedKey.replaceAll("-", "").trim();
  };

  handleLocationSearch = (newValue) => {
    this.setState({ locationSearch: newValue, appliedFilterName: "" }, () => {
      this.SearchInventoryWatchesdetails();
    });
  };

  getFilterDetails = async (propsData) => {
    const { userData } = this.state;
    const payload = {
      userId: userData?.userId,
      accountid: userData?.accountId,
    };

    const response = await new Promise((resolve, reject) => {
      searchinventry.getInventoryFilterDetails(payload, (err, res) => {
        if (err) {
          showErrorToast(err);
          reject(err);
        } else {
          resolve(res);
        }
      });
    });

    if (response?.data) {
      await new Promise((resolve) => {
        this.setState({ filterData: response.data }, async () => {
          const { filterData, defaultManuallyCleared, isNewFilterBeingSaved } =
            this.state;
          const defaultFilter = filterData.find((f) => f.setasdefault === true);

          if (
            defaultFilter &&
            !defaultManuallyCleared &&
            !isNewFilterBeingSaved &&
            Object.keys(propsData || {}).length === 0
          ) {
            await new Promise((res) => {
              this.setState(
                {
                  soldStatus: defaultFilter?.sold ?? "",
                  paidStatus: defaultFilter?.invoicestatus ?? "",
                  brand_id: defaultFilter?.brand_id ?? "",
                  brand_description: defaultFilter?.brand_name ?? "",
                  type: defaultFilter?.type ?? "",
                  InventoryCategory: defaultFilter?.category ?? "",
                  InventoryStatus: defaultFilter?.inventory_status ?? "",
                  InventoryType: defaultFilter?.inventory_type ?? "",
                  appliedFilterName: defaultFilter?.filtername || "",
                },
                res,
              );
            });
          }
          resolve();
        });
      });
    }
  };

  handleOpenApplyFilter = () => {
    this.setState({ openApplyFilter: true });
  };

  handleCloseApplyFilter = () => {
    this.setState({ openApplyFilter: false });
  };
  handleOpenSaveFilter = () => {
    this.setState({ saveFilter: true });
  };

  handleCloseSaveFilter = () => {
    this.setState({ saveFilter: false, filterName: "" });
  };

  handleFilterName = (e) => {
    this.setState({ filterName: e.target.value });
  };

  handleSaveFilter = () => {
    const {
      userData,
      filterName,
      soldStatus,
      paidStatus,
      brand_id,
      brand_description,
      type,
      InventoryCategory,
      InventoryStatus,
      InventoryType,
      setAsDefault,
    } = this.state;

    const payload = {
      userId: userData?.userId,
      accountid: userData?.accountId,
      filterName: filterName,
      sold: soldStatus || null,
      invoicestatus: paidStatus || null,
      brand_id: brand_id || null,
      brand_name: brand_description || null,
      type: type || null,
      category: InventoryCategory || null,
      inventory_status: InventoryStatus ? InventoryStatus : null,
      inventory_type: InventoryType || null,
      setasdefault: setAsDefault,
    };

    searchinventry.saveInventoryFilterDetails(payload, (err, response) => {
      if (response?.status === 1) {
        showSuccessToast("Filter saved successfully");
        this.setState({
          saveFilter: false,
          filterName: "",
          appliedFilterName: filterName,
          isNewFilterBeingSaved: true,
          //setAsDefault: false,
        });
        this.getFilterDetails();
      }
      if (err) {
        showErrorToast(err);
      }
    });
  };

  handleSetAsDefault = () => {
    this.setState((prevState) => ({
      setAsDefault: !prevState.setAsDefault,
    }));
  };

  handleFilterCheckboxChange = (id) => {
    const { selectedRowIds } = this.state;

    const alreadySelected = selectedRowIds.includes(id);
    let updatedIds = [];

    if (alreadySelected) {
      updatedIds = selectedRowIds.filter((itemId) => itemId !== id);
    } else {
      updatedIds = [...selectedRowIds, id];
    }

    this.setState({
      selectedRowIds: updatedIds,
      selectedFilterId: updatedIds.length === 1 ? updatedIds[0] : null,
    });
  };

  handleApplyFilter = () => {
    const { filterData, selectedFilterId } = this.state;
    const selectedRow = filterData.find((row) => row.id === selectedFilterId);
    if (!selectedRow) return;

    this.setState(
      {
        soldStatus: selectedRow?.sold ?? "",
        paidStatus: selectedRow?.invoicestatus ?? "",
        brand_id: selectedRow?.brand_id ?? "",
        brand_description: selectedRow?.brand_name ?? "",
        type: selectedRow?.type ?? "",
        InventoryCategory: selectedRow?.category ?? "",
        InventoryStatus: selectedRow?.inventory_status ?? "",
        InventoryType: selectedRow?.inventory_type ?? "",
        filterName: selectedRow?.filterName || "",
        appliedFilterName: selectedRow?.filtername || "",
        setAsDefault: selectedRow?.setasdefault || false,
        openApplyFilter: false,
        selectedFilterId: null,
        selectedFilterData: null,
        selectedRowIds: [],
      },
      () => {
        this.SearchInventoryWatchesdetails();
      },
    );
  };

  openDeleteConfirmModal = () => {
    this.setState({ openDeleteConfirmModal: true });
  };

  closeDeleteConfirmModal = () => {
    this.setState({ openDeleteConfirmModal: false });
  };

  handleDeleteFilter = () => {
    const { selectedRowIds, filterData, appliedFilterName } = this.state;

    if (selectedRowIds.length === 0) return;

    const isDefaultDeleted = filterData.some(
      (f) => selectedRowIds.includes(f.id) && f.setasdefault === true,
    );
    const isAppliedDeleted = filterData.some(
      (f) =>
        selectedRowIds.includes(f.id) && f.filtername === appliedFilterName,
    );

    const payload = { id: selectedRowIds };

    searchinventry.deleteInventoryFilters(payload, (err, response) => {
      if (response?.status === 1) {
        let updatedState = {
          selectedRowIds: [],
          selectedFilterId: null,
        };

        if (isDefaultDeleted && !isAppliedDeleted) {
          this.defaultManuallyCleared = true;
        }

        if (isAppliedDeleted) {
          const defaultFilter = filterData.find(
            (f) => f.setasdefault === true && !selectedRowIds.includes(f.id),
          );
          if (defaultFilter) {
            updatedState = {
              ...updatedState,
              soldStatus: defaultFilter?.sold ?? "",
              paidStatus: defaultFilter?.invoicestatus ?? "",
              BrandName: defaultFilter?.brand?.brand ?? [],
              type: defaultFilter?.type ?? "",
              InventoryCategory: defaultFilter?.category ?? "",
              InventoryStatus: defaultFilter?.inventory_status ?? "",
              InventoryType: defaultFilter?.inventory_type ?? "",
              appliedFilterName: defaultFilter?.filtername || "",
            };
          } else {
            this.defaultManuallyCleared = true;
            updatedState = {
              ...updatedState,
              soldStatus: "",
              paidStatus: "",
              BrandName: [],
              type: "",
              InventoryCategory: "",
              InventoryStatus: "",
              InventoryType: "",
              appliedFilterName: "",
            };
          }
        }

        this.setState(updatedState, () => {
          this.getFilterDetails();
          this.SearchInventoryWatchesdetails();
        });

        this.handleCloseApplyFilter();
        showSuccessToast("Deleted Successfully");
      } else {
        showErrorToast(err || "Failed to delete filter");
      }

      this.closeDeleteConfirmModal();
    });
  };

  handleClearFilter = () => {
    const defaultFilter = this.state.filterData?.find(
      (f) => f.setasdefault === true,
    );
    const { appliedFilterName } = this.state;

    if (
      defaultFilter &&
      appliedFilterName?.toLowerCase() ===
      defaultFilter?.filtername?.toLowerCase()
    ) {
      this.setState(
        {
          soldStatus: "",
          paidStatus: "",
          brand_id: "",
          brand_description: "",
          type: "standand_and_misc",
          InventoryCategory: "",
          InventoryStatus: "",
          InventoryType: "",
          appliedFilterName: "",
          selectedRowIds: [],
          selectedFilterId: null,
          defaultManuallyCleared: true,
        },
        () => {
          this.SearchInventoryWatchesdetails();
        },
      );
    } else if (defaultFilter) {
      this.setState(
        {
          soldStatus: defaultFilter?.sold ?? "",
          paidStatus: defaultFilter?.invoicestatus ?? "",
          brand_id: defaultFilter?.brand_id ?? "",
          brand_description: defaultFilter?.brand_name ?? "",
          type: defaultFilter?.type ?? "",
          InventoryCategory: defaultFilter?.category ?? "",
          InventoryStatus: defaultFilter?.inventory_status ?? "",
          InventoryType: defaultFilter?.inventory_type ?? "",
          appliedFilterName: defaultFilter?.filtername || "",
          selectedRowIds: [],
          selectedFilterId: null,
        },
        () => {
          this.SearchInventoryWatchesdetails();
        },
      );
    } else {
      this.setState(
        {
          soldStatus: "",
          paidStatus: "",
          brand_id: "",
          brand_description: "",
          type: "",
          InventoryCategory: "",
          InventoryStatus: "",
          InventoryType: "",
          appliedFilterName: "",
          selectedRowIds: [],
          selectedFilterId: null,
        },
        () => {
          this.SearchInventoryWatchesdetails();
        },
      );
    }
  };

  getValue = (type, id) => {
    if (type === "type") {
      const type = typeFilter.find((item) => item.id === id);
      return type?.value || id;
    }
    if (type === "inventory_status") {
      const type = inventoryStatusFilter.find((item) => item.id === id);
      return renderInventoryStatusLabel(id, type?.value || id);
    }
    if (type === "sold") {
      const type = soldStatusFilter.find((item) => item.id === id);
      return type?.value || id;
    }
    if (type === "inventory_type") {
      const type = inventoryTypeFilter.find((item) => item.id === id);
      return type?.value || id;
    }
    if (type === "invoicestatus") {
      const type = invoiceStatusFilter.find((item) => item.id === id);
      return type?.value || id;
    }
    if (type === "category") {
      const type = categoryFilter.find((item) => item.id === id);
      return type?.value || id;
    }
    if (type === "setasdefault") {
      return id === true ? "True" : "False";
    } else {
      return id;
    }
  };

  onToggleDefault = (row) => {
    if (!row.setasdefault) {
      this.setState({
        confirmDefaultFilter: true,
        pendingDefaultFilter: row,
      });
    }
  };

  onCancelDefaultChange = () => {
    this.setState({
      confirmDefaultFilter: false,
      pendingDefaultFilter: null,
    });
  };

  onConfirmDefaultChange = () => {
    const { pendingDefaultFilter } = this.state;
    if (!pendingDefaultFilter?.id) return;
    const { id } = pendingDefaultFilter;

    searchinventry.updateSetAsDefaultInventoryFilter(
      id,
      { setasdefault: true },
      (err, res) => {
        if (res?.status === 1) {
          showSuccessToast("Default filter updated successfully");
          this.setState(
            {
              confirmDefaultFilter: false,
              pendingDefaultFilter: null,
              openApplyFilter: false,
              defaultManuallyCleared: false,
            },
            () => {
              this.getFilterDetails().then(() => {
                this.SearchInventoryWatchesdetails();
              });
            },
          );
        } else {
          showErrorToast(err || "Failed to update default filter");
        }
      },
    );
  };

  handleShareInventory = () => {
    let {
      selectedItems,
      userData,
      accountId,
      selectAll,
      key,
      brand_id,
      brand_description,
      paidStatus,
      soldStatus,
      DialColor,
      locationSearch,
      contactName,
      contactType,
      inventoryxlid,
      InventoryType,
      InventoryStatus,
      purchasedate,
      type,
      InventoryCategory,
    } = this.state;
    this.setState({ disabled: true });
    const data = selectAll
      ? {
        accountId: accountId,
        userId: userData?.userId,
        brand_id: brand_id,
        brand_name: brand_description,
        key: this.sanitizeKey(key),
        invoicestatus: paidStatus,
        sold: soldStatus,
        dial_color: DialColor,
        location_id: locationSearch?.id,
        contactname: contactName,
        contacttype: contactType,
        inventoryxlid: this.normalizeInventoryXlId(inventoryxlid),
        inventory_type: InventoryType,
        inventory_status: InventoryStatus,
        purchace_date:
          purchasedate === 0
            ? "ALL"
            : purchasedate > 180
              ? "UNKNOWN"
              : purchasedate,
        type: type === "ALL" ? "" : type,
        ...(InventoryCategory !== "ALL" && { category: InventoryCategory }),
        product_image: this.state.productImage,
      }
      : {
        accountId: accountId,
        inventoryId: selectedItems,
        userId: userData?.userId,
      };
    shareInventories(data, (error, res) => {
      if (error) {
        showErrorToast(error);
        this.setState({ disabled: false });
      } else {
        if (res.success == 1) {
          this.copyToClipboard(res?.data);
          this.setState({ openShareModal: false, disabled: false });
        } else {
          showErrorToast(res.message);
          this.setState({ disabled: false });
        }
      }
    });
  };
  sendToShopifyInventory = () => {
    let {
      selectedItems,
      userData,
      accountId,
      selectAll,
      key,
      brand_id,
      brand_description,
      paidStatus,
      soldStatus,
      DialColor,
      locationSearch,
      contactName,
      contactType,
      inventoryxlid,
      InventoryType,
      InventoryStatus,
      purchasedate,
      type,
      InventoryCategory,
    } = this.state;
    this.setState({ disabled: true, shopifySyncLoading: true });

    const data = selectAll
      ? {
        accountId: accountId,
        userId: userData?.userId,
        brand_id: brand_id,
        brand_name: brand_description,
        key: this.sanitizeKey(key),
        invoicestatus: paidStatus,
        sold: soldStatus,
        dial_color: DialColor,
        location_id: locationSearch?.id,
        contactname: contactName,
        contacttype: contactType,
        inventoryxlid: this.normalizeInventoryXlId(inventoryxlid),
        inventory_type: InventoryType,
        inventory_status: InventoryStatus,
        purchace_date:
          purchasedate === 0
            ? "ALL"
            : purchasedate > 180
              ? "UNKNOWN"
              : purchasedate,
        type: type === "ALL" ? "" : type,
        ...(InventoryCategory !== "ALL" && { category: InventoryCategory }),
        product_image: this.state.productImage,
      }
      : {
        accountId: accountId,
        inventoryId: selectedItems,
        userId: userData?.userId,
      };

    if (this.props.sendToShopify) {
      this.props.sendToShopify(data, (error, res) => {
        if (error) {
          showErrorToast(error);
          this.setState({ disabled: false, shopifySyncLoading: false });
          return;
        }
        const results = res?.results || [];
        this.setState({
          shopifySyncResult: results,
          showShopifyResultDialog: true,
          disabled: false,
          shopifySyncLoading: false,
        });
      });
    } else if (this.props.dispatch) {
      this.props.dispatch(
        sendToShopify(data, (error, res) => {
          if (error) {
            showErrorToast(error);
            this.setState({ disabled: false, shopifySyncLoading: false });
            return;
          }
          const results = res?.results || [];
          this.setState({
            shopifySyncResult: results,
            showShopifyResultDialog: true,
            disabled: false,
            shopifySyncLoading: false,
          });
        }),
      );
    } else {
      sendToShopify(data, (error, res) => {
        if (error) {
          showErrorToast(error);
          this.setState({ disabled: false, shopifySyncLoading: false });
          return;
        }
        const results = res?.results || [];
        this.setState({
          shopifySyncResult: results,
          showShopifyResultDialog: true,
          disabled: false,
          shopifySyncLoading: false,
        });
      });
    }
  };

  handleRetryShopify = (failedIds = []) => {
    if (!failedIds || failedIds.length === 0) return;
    const data = { inventoryId: failedIds };
    // show loader during retry
    this.setState({ shopifySyncLoading: true, disabled: true });

    const finalizeRetry = (results) => {
      this.setState({
        shopifySyncResult: results,
        showShopifyResultDialog: true,
        shopifySyncLoading: false,
        disabled: false,
      });
    };

    const handleRetryError = (err) => {
      showErrorToast(err || "Failed to retry Shopify sync");
      this.setState({ shopifySyncLoading: false, disabled: false });
    };

    if (this.props.sendToShopify) {
      this.props.sendToShopify(data, (error, res) => {
        if (error) return handleRetryError(error);
        const results = res?.results || [];
        return finalizeRetry(results);
      });
    } else if (this.props.dispatch) {
      this.props.dispatch(
        sendToShopify(data, (error, res) => {
          if (error) return handleRetryError(error);
          const results = res?.results || [];
          return finalizeRetry(results);
        }),
      );
    } else {
      sendToShopify(data, (error, res) => {
        if (error) return handleRetryError(error);
        const results = res?.results || [];
        return finalizeRetry(results);
      });
    }
  };
  sendToEbayInventory = () => {
    let {
      selectedItems,
      userData,
      accountId,
      selectAll,
      key,
      brand_id,
      brand_description,
      paidStatus,
      soldStatus,
      DialColor,
      contactName,
      contactType,
      inventoryxlid,
      InventoryType,
      InventoryStatus,
      purchasedate,
      type,
      InventoryCategory,
    } = this.state;
    this.setState({ disabled: true, ebaySyncLoading: true });

    const data = selectAll
      ? {
        accountId: accountId,
        brand_id: brand_id,
        brand_name: brand_description,
        key: this.sanitizeKey(key),
        invoicestatus: paidStatus,
        sold: soldStatus,
        dial_color: DialColor,
        contactname: contactName,
        contacttype: contactType,
        inventoryxlid: this.normalizeInventoryXlId(inventoryxlid),
        inventory_type: InventoryType,
        inventory_status: InventoryStatus,
        purchace_date:
          purchasedate === 0
            ? "ALL"
            : purchasedate > 180
              ? "UNKNOWN"
              : purchasedate,
        type: type === "ALL" ? "" : type,
        category: InventoryCategory !== "ALL" ? InventoryCategory : "",
        product_image: this.state.productImage,
        userId: userData?.userId,
      }
      : {
        accountId: accountId,
        inventoryId: selectedItems,
        userId: userData?.userId,
      };

    sendToEbay(data, (error, res) => {
      if (error) {
        showErrorToast(error);
        this.setState({ disabled: false, ebaySyncLoading: false });
        return;
      }
      const results = res?.results || [];
      this.setState({
        ebaySyncResult: results,
        showEbayResultDialog: true,
        disabled: false,
        ebaySyncLoading: false,
      });
      this.SearchInventoryWatchesdetails();
    });
  };
  handleRetryEbay = (failedIds = []) => {
    if (!failedIds || failedIds.length === 0) return;
    const data = { inventoryId: failedIds };
    this.setState({ ebaySyncLoading: true, disabled: true });

    sendToEbay(data, (error, res) => {
      if (error) {
        showErrorToast(error || "Failed to retry eBay sync");
        this.setState({ ebaySyncLoading: false, disabled: false });
        return;
      }
      const results = res?.results || [];
      this.setState({
        ebaySyncResult: results,
        showEbayResultDialog: true,
        ebaySyncLoading: false,
        disabled: false,
      });
      this.SearchInventoryWatchesdetails();
    });
  };

  handleOpenModal = (inventoryDetails) => {
    this.setState({ modalOpen: true, selectedInventoryData: inventoryDetails });
  };

  handleCloseModal = () => {
    this.setState({ modalOpen: false, selectedInventoryData: null });
  };

  mapInventoryDetails = (data) => {
    const {
      type,
      technical_details,
      prodattr,
      serialno,
      productid,
      inventory_title,
      imagepaths,
      product_imagepaths,
      inventoryid,
      purchaseprice,
      quantity,
      description,
    } = data ?? {};
    const isMisc = type === "misc_product" || type === "misc_watch";
    const { product_title, product_name } = technical_details ?? {};
    const { reference, model } = prodattr ?? {};
    const {
      front,
      back,
      left,
      right,
      wrist_shot,
      buckle_closed,
      buckle_opened,
      free_form,
    } = imagepaths ?? {};

    return {
      model: isMisc ? product_title || product_name || inventory_title || "" : reference,
      serialno,
      productid,
      desc: isMisc
        ? product_title || product_name || inventory_title || ""
        : inventory_title || model || "",
      image:
        front ||
        back ||
        left ||
        right ||
        wrist_shot ||
        buckle_opened ||
        buckle_closed ||
        free_form ||
        product_imagepaths?.images?.[0] ||
        imageNotAvailable,
      inventoryid,
      purchaseprice,
      quantity,
      productName: isMisc ? product_title || product_name || "" : description,
      type,
    };
  };

  handleAutoComplete = (event, newValue) => {
    const selectedIds = newValue.map((option) => option.id);
    this.setState({ contactType: selectedIds, appliedFilterName: "" }, () => {
      this.SearchInventoryWatchesdetails();
    });
  };

  inventoryrender() {
    const { classes } = this.props;
    const {
      hoveredCard,
      selectedItems,
      totalCostforInventory,
      noOfItemsInventory,
      selectAll,
      userData,
      soldStatus,
      modalOpen,
      selectedInventoryData,
      invoiceType,
    } = this.state;
    let inventoryList = [];
    // if (
    //   this.state.searchEnabled &&
    //   (this.state.key !== "" ||
    //     this.state.brand_id !== "" ||
    //     this.state.soldStatus !== "" ||
    //     this.state.inventoryxlid !== "" ||
    //     this.state.InventoryType !== "" ||
    //     this.state.InventoryStatus !== ""
    //   )
    // )
    if (this.state.updateIntiate) {
      inventoryList = this.state.updatedInvenentryList;
    } else {
      inventoryList = this.props.InventoryList.data;
    }
    const brandInfo = this.props.brandInfo.data;
    // const dialColorInfo = this.props.dialColorInfo.data;
    const inventoryXlIdInfo = this.props.inventoryXlIdInfo.data;
    // const totalCostforInventory = this.calculateTotalCostforInventory(inventoryList);
    return (
      <div
        className="space-bottom-30 someextrahight"
        style={{ marginTop: "10px" }}
      >
        <Tooltip title="Scroll to top" arrow>
          <div
            style={{
              position: "fixed",
              bottom: "90px",
              right: "50px",
            }}
          >
            <ScrollUpButton
              EasingType="easeInOutBounce"
              ShowAtPosition={1000}
              AnimationDuration={500}
              style={{
                backgroundColor: "#CEA05F",
                borderRadius: "50%",
                padding: "10px",
                border: "none",
                fill: "#fff",
                marginRight: "5px",
                bottom: "85px",
              }}
            />
          </div>
        </Tooltip>
        <Container>
          {/* <div style={{ marginBottom: "20px" ,wordBreak:"break-word"}}>
                        <a href="">
                        {inventoryList && inventoryList.length > 0 ? <Alert severity="info" className="info">
           
           
                        Your Chrono24 xml url is <strong> URL(https://api.watchops.com/inventories/{this.props.currentUser.userId}/c24-importer.xml)</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <Tooltip title="Copy">
                          <IconButton aria-label="copy" onClick={this.copy}>
                             <FileCopyIcon />
                          </IconButton>
                        </Tooltip>
                        </Alert> : ""}
                       
                        </a>
                    </div> */}
          <Grid container spacing={1}>
            <Grid item xs={12} md={4}>
              <Typography type="title" color="inherit">
                <h1>
                  <b>MY INVENTORY</b>
                </h1>
              </Typography>
            </Grid>
            {!isActionAllowed(this.state.accessData, "download_inventory") && (
              <Grid item xs={12} md={4}></Grid>
            )}
            <Grid
              item
              xs={6}
              md={
                this.props?.InventoryList?.data?.length > 0 &&
                  this.props?.InventoryList?.data[0]?.dealerpublish
                  ? 2
                  : 4
              }
              style={{ margin: "auto" }}
            >
              <Button
                id="demo-customized-button"
                // aria-controls={open ? 'demo-customized-menu' : undefined}
                aria-haspopup="true"
                // aria-expanded={open ? 'true' : undefined}
                variant="contained"
                disableElevation
                onClick={() =>
                  this.setState({ filterEnable: !this.state.filterEnable })
                }
                className={"text-capitalize primary-bg color-white background"}
                style={{ float: "right" }}
                endIcon={
                  this.state.filterEnable ? (
                    <FilterAltIcon />
                  ) : (
                    <FilterAltOffIcon />
                  )
                }
              >
                &nbsp;Filter
              </Button>
            </Grid>
            {this.props?.InventoryList?.data?.length > 0 &&
              this.props?.InventoryList?.data[0]?.dealerpublish ? (
              <Grid item xs={6} md={2} style={{ margin: "auto" }}>
                <Button
                  id="demo-customized-button"
                  // aria-controls={open ? 'demo-customized-menu' : undefined}
                  aria-haspopup="true"
                  // aria-expanded={open ? 'true' : undefined}
                  variant="contained"
                  disableElevation
                  onClick={() => this.copyToClipboard()}
                  className={"text-capitalize primary-bg color-white"}
                  style={{ float: "right" }}
                // endIcon={<KeyboardArrowDownOutlined />}
                >
                  <Share />
                  &nbsp;Share Inventory
                </Button>
              </Grid>
            ) : null}
            {isActionAllowed(this.state.accessData, "download_inventory") && (
              <>
                <Grid item xs={6} md={2} style={{ margin: "auto" }}>
                  <CustomizedUploadMenus
                    downloadInventory={this.downloadInventory}
                    history={this.props?.history}
                  />
                </Grid>
                <Grid item xs={6} md={2} style={{ margin: "auto" }}>
                  <CustomizedMenus downloadInventory={this.downloadInventory} />
                </Grid>
              </>
            )}
            <Grid
              item
              xs={12}
              md={12}
              style={{ display: "flex", columnGap: "10px" }}
              alignItems="center"
              justifyContent="flex-end"
            >
              {this.state.appliedFilterName !== "" && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "3px 7px",
                    borderRadius: "5px",
                    border: "1px solid rgba(0, 0, 0, 0.23)",
                  }}
                >
                  <Typography variant="p">
                    {this.state.filterData.find(
                      (f) =>
                        f.setasdefault &&
                        f.filtername === this.state.appliedFilterName,
                    )
                      ? `Default Filter - ${this.state.appliedFilterName}`
                      : `Applied Filter - ${this.state.appliedFilterName}`}
                  </Typography>
                  <IconButton
                    onClick={this.handleClearFilter}
                    aria-label="clear filter"
                    size="small"
                    style={{ marginLeft: "10px" }}
                  >
                    <ClearIcon />
                  </IconButton>
                </div>
              )}
              <Button
                variant="contained"
                className="text-capitalize primary-bg color-white"
                onClick={this.handleOpenApplyFilter}
                endIcon={<FilterAltOffIcon />}
              >
                Apply Filter
              </Button>
              <Button
                variant="contained"
                className="text-capitalize primary-bg color-white"
                onClick={this.handleOpenSaveFilter}
              >
                Save Filter
              </Button>
            </Grid>
            <Dialog
              open={this.state.openApplyFilter}
              onClose={this.handleCloseApplyFilter}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              maxWidth="lg"
            >
              <DialogTitle id="alert-dialog-title">
                FILTERS
                <IconButton
                  onClick={this.handleCloseApplyFilter}
                  style={{ float: "right" }}
                  className="noprint"
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          {columns.map((column) => (
                            <StyledTableCell
                              key={column.id}
                              align={column.align}
                              style={{ minWidth: column.minWidth }}
                            >
                              {column.label}
                            </StyledTableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.filterData?.length ? (
                          <>
                            {this.state.filterData?.map((row, index) => {
                              return (
                                <TableRow hover tabIndex={-1} key={row?.code}>
                                  {columns.map((column) => {
                                    if (column.id === "checkbox") {
                                      return (
                                        <TableCell key={row.id}>
                                          <Checkbox
                                            color="primary"
                                            checked={this.state.selectedRowIds.includes(
                                              row.id,
                                            )}
                                            onChange={() =>
                                              this.handleFilterCheckboxChange(
                                                row.id,
                                              )
                                            }
                                          />
                                        </TableCell>
                                      );
                                    }
                                    let value = row[column.id];
                                    if (column.id === "setasdefault") {
                                      value = (
                                        <Switch
                                          checked={row.setasdefault}
                                          onChange={() =>
                                            this.onToggleDefault(row)
                                          }
                                        />
                                      );
                                    } else {
                                      value = this.getValue(column.id, value);
                                    }
                                    return (
                                      <TableCell
                                        key={column.id}
                                        align={column.align}
                                      >
                                        {value}
                                      </TableCell>
                                    );
                                  })}
                                </TableRow>
                              );
                            })}{" "}
                          </>
                        ) : (
                          <TableCell
                            colspan={12}
                            style={{ textAlign: "center" }}
                          >
                            <Typography variant="h6" className="color-BCBCBC">
                              No Record Found
                            </Typography>
                          </TableCell>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="contained"
                  color="error"
                  style={{
                    backgroundColor: "#d32f2f",
                    color: "#fff",
                    opacity: this.state.selectedRowIds?.length === 0 ? 0.4 : 1,
                  }}
                  disabled={this.state.selectedRowIds?.length === 0}
                  onClick={this.openDeleteConfirmModal}
                //disabled={selectedRowIds?.length === 0} onClick={handleDeleteConfirm}
                >
                  Delete
                </Button>
                <Button
                  className="primary-bg color-white"
                  variant="contained"
                  color="primary"
                  disabled={
                    this.state.selectedRowIds?.length === 0 ||
                    this.state.selectedRowIds?.length > 1
                  }
                  style={{
                    opacity:
                      this.state.selectedRowIds?.length === 0 ||
                        this.state.selectedRowIds?.length > 1
                        ? 0.4
                        : 1,
                    marginRight: "25px",
                  }}
                  onClick={this.handleApplyFilter}
                >
                  Apply
                </Button>
              </DialogActions>
              <Dialog
                open={this.state.openDeleteConfirmModal}
                onClose={this.closeDeleteConfirmModal}
                fullWidth
                maxWidth="sm"
              >
                <DialogTitle>
                  Delete Filter
                  <IconButton
                    onClick={this.closeDeleteConfirmModal}
                    style={{ float: "right" }}
                  >
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent>
                  <div>
                    {" "}
                    Are you sure you want to <b>Delete</b>?{" "}
                  </div>
                </DialogContent>
                <DialogActions>
                  <Button
                    color="primary"
                    onClick={this.closeDeleteConfirmModal}
                  >
                    Cancel
                  </Button>
                  <Button color="primary" onClick={this.handleDeleteFilter}>
                    Ok
                  </Button>
                </DialogActions>
              </Dialog>
            </Dialog>
            <Dialog
              open={this.state.confirmDefaultFilter}
              onClose={this.onCancelDefaultChange}
              fullWidth
              maxWidth="sm"
            >
              <DialogTitle>
                Set as Default Filter
                {/* <IconButton onClick={this.onCancelDefaultChange} style={{ float: 'right' }}>
                  <CloseIcon />
                </IconButton> */}
              </DialogTitle>

              <DialogContent>
                <div>
                  Are you sure you want to set{" "}
                  <b>{this.state.pendingDefaultFilter?.filtername}</b> as your
                  default filter?
                </div>
              </DialogContent>

              <DialogActions>
                <Button color="primary" onClick={this.onCancelDefaultChange}>
                  Cancel
                </Button>
                <Button color="primary" onClick={this.onConfirmDefaultChange}>
                  Ok
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog
              open={this.state.saveFilter}
              onClose={this.handleCloseSaveFilter}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              maxWidth="md"
            >
              <DialogTitle id="alert-dialog-title">
                ADD FILTER
                <IconButton
                  onClick={this.handleCloseSaveFilter}
                  style={{ float: "right" }}
                  className="noprint"
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <FormControl style={{ width: "450px", margin: "10px 0px" }}>
                    {/* <TextField
                                    id="outlined-basic"
                                    label="Enter Filter Name"
                                    variant="standard"
                                    value={filterName}
                                    onChange={(e) => {
                                        setFilterName(e.target.value);
                                    }}
                                /> */}
                    <InputLabel
                      htmlFor="component-simple"
                      style={{ color: "#424242" }}
                    >
                      ENTER FILTER NAME
                    </InputLabel>
                    <Input
                      id="component-simple"
                      value={this.state.filterName}
                      onChange={this.handleFilterName}
                      //value={filterName}
                      // onChange={(e) => {
                      // setFilterName(e.target.value);
                      // }}
                      inputProps={{ maxLength: 100 }}
                    />
                  </FormControl>
                  <div style={{ margin: "10px 0px" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          checked={this.state.setAsDefault}
                          onChange={this.handleSetAsDefault}
                        />
                      }
                      label="Set as Default Filter"
                    />
                  </div>
                  <Typography variant="inherit" className="color-454545">
                    <i>
                      Note: Clicking the "Save" button will save only the
                      selected values for Sold/Unsold,
                      <br /> Paid Status, Brand, Type, Category, Inventory
                      Status, and Inventory Type.
                    </i>
                  </Typography>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="contained"
                  color="inherit"
                  onClick={this.handleCloseSaveFilter}
                >
                  Cancel
                </Button>
                <Button
                  className="primary-bg color-white"
                  style={{ opacity: !this.state.filterName ? 0.4 : 1 }}
                  variant="contained"
                  color="primary"
                  disabled={!this.state.filterName}
                  onClick={this.handleSaveFilter}
                >
                  Save
                </Button>
              </DialogActions>
            </Dialog>
            <Grid item xs={12} sm={12} md={3}>
              <span onClick={this.removeSoldUnsold} style={{ float: "right" }}>
                <Icon
                  className={this.state.soldStatus ? "fa fa-times-circle" : ""}
                />
              </span>
              <FormControl variant="outlined" className="formControl">
                <InputLabel
                  id="demo-simple-select-outlined-label"
                  className="font-14"
                >
                  Sold / Unsold
                </InputLabel>
                <Select
                  style={{ color: "black" }}
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  onChange={this.handleChangeOfSoldUnSold}
                  label="Sold / Unsold"
                  value={this.state.soldStatus}
                >
                  <MenuItem value="ALL">All</MenuItem>
                  <MenuItem value="1">Sold</MenuItem>
                  <MenuItem value="0">Unsold</MenuItem>
                  <MenuItem value="Void">Void</MenuItem>
                </Select>
              </FormControl>
              {/* <Typography
                      variant="h6"
                      className="color-383838"
                      style={{ fontSize: "15px" }}
                    >
                      {" "}
                      {this.state.soldStatus === "1" ? "Sold" : ""}{" "}
                      {this.state.soldStatus === "0" ? "Unsold" : " "}{" "}
                    </Typography> */}
            </Grid>
            <Grid item xs={12} sm={12} md={3}>
              <span onClick={this.removePaidStatus} style={{ float: "right" }}>
                <Icon
                  className={this.state.paidStatus ? "fa fa-times-circle" : ""}
                />
              </span>
              <FormControl variant="outlined" className="formControl">
                <InputLabel
                  id="demo-simple-select-outlined-label"
                  className="font-14"
                >
                  Paid Status
                </InputLabel>
                <Select
                  style={{ color: "black" }}
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  onChange={this.handleChangeOfPaidStatus}
                  label="Paid Status"
                  value={this.state.paidStatus}
                >
                  <MenuItem value="ALL">All</MenuItem>
                  <MenuItem value="paid">Paid</MenuItem>
                  <MenuItem value="notPaid">Not Paid</MenuItem>
                </Select>
              </FormControl>
              {/* <Typography
                      variant="h6"
                      className="color-383838"
                      style={{ fontSize: "15px" }}
                    >
                      {" "}
                      {this.state.soldStatus === "1" ? "Sold" : ""}{" "}
                      {this.state.soldStatus === "0" ? "Unsold" : " "}{" "}
                    </Typography> */}
            </Grid>
            <Grid item xs={12} sm={12} md={3}>
              <span onClick={this.removebrandname} style={{ float: "right" }}>
                <Icon
                  className={
                    // this.state.modledata ? "fa fa-times-circle" : ""
                    this.state.brand_id ? "fa fa-times-circle" : ""
                  }
                />
              </span>
              <FormControl variant="outlined" className="formControl">
                <InputLabel
                  id="demo-simple-select-outlined-label"
                  className="font-14"
                >
                  Brand
                </InputLabel>
                <Select
                  style={{ color: "black" }}
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  onChange={this.handleChangeOfBrandByBrandName}
                  label="Brand"
                  value={this.state.brand_id}
                >
                  <MenuItem value="ALL">All</MenuItem>
                  {brandInfo &&
                    brandInfo.map((row) => (
                      <MenuItem key={row.brandid} value={row.brandid}>
                        {row.brandname}
                      </MenuItem>
                    ))}
                </Select>
                {/* <Typography
                          variant="h6"
                          className="color-383838"
                          style={{ fontSize: "15px" }}
                        >
                          {this.state.modledata
                            ? this.state.modledata
                            : this.state.removedbrndname}{" "}
                        </Typography> */}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={3}>
              <span
                onClick={this.removeBulkUploadId}
                style={{ float: "right" }}
              >
                <Icon
                  className={
                    this.state.inventoryxlid ? "fa fa-times-circle" : ""
                  }
                />
              </span>
              <FormControl variant="outlined" className="formControl">
                <InputLabel
                  id="demo-simple-select-outlined-label"
                  className="font-14"
                >
                  Bulk Upload Id
                </InputLabel>
                <Select
                  style={{ color: "black" }}
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  onChange={this.handleChangeOfBulkUploadId}
                  label="Bulk Upload Id"
                  value={this.state.inventoryxlid || "ALL"}
                >
                  <MenuItem value="ALL">All</MenuItem>
                  {inventoryXlIdInfo &&
                    inventoryXlIdInfo.map((row) => (
                      <MenuItem
                        key={row.inventoryxlid}
                        value={row.inventoryxlid}
                      >
                        {row?.inventoryxl_name
                          ? row.inventoryxl_name.replace("-", " (") + ")"
                          : ""}
                        {/* {row?.inventoryxl_name} */}
                      </MenuItem>
                    ))}
                </Select>
                {/* <Typography variant="h6" className="color-383838" style={{ fontSize: "15px" }}>{this.state.inventoryxlid ? this.state.inventoryxlid : this.state.removeBulkUploadId}   </Typography> */}
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl
                className="form-width-99"
                onSubmit={(e) => {
                  e.preventDefault();
                  this.SearchInventoryWatchesdetails();
                }}
              >
                <div style={{ marginTop: "3%", marginBottom: "10px" }}>
                  <Paper
                    // component="form"
                    style={{ height: "50px", display: "flex" }}
                  >
                    <InputBase
                      fullWidth
                      sx={{ ml: 3, flex: 1 }}
                      inputProps={{
                        "aria-label": "Enter Dial Color",
                      }}
                      placeholder="Enter Dial Color"
                      // defaultValue={this.state.key}
                      onChange={this.handleChangeOfDialColor}
                      onKeyPress={this.handleEnterEvent}
                      value={this.state.DialColor}
                      endAdornment={this.dialColorAdornment()}
                    />
                  </Paper>
                </div>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl
                className="form-width-99"
                onSubmit={(e) => {
                  e.preventDefault();
                  this.SearchInventoryWatchesdetails();
                }}
              >
                <div style={{ marginTop: "3%", marginBottom: "10px" }}>
                  <Paper
                    // component="form"
                    style={{ height: "50px", display: "flex" }}
                  >
                    <InputBase
                      fullWidth
                      sx={{ ml: 3, flex: 1 }}
                      inputProps={{
                        "aria-label":
                          "Enter Serial No / Model No / Notes / Inventory Id / Inventory Title",
                      }}
                      placeholder="Enter Serial No / Model No / Notes / Inventory Id / Inventory Title"
                      // defaultValue={this.state.key}
                      onChange={this.onChangeOfFirstName}
                      onKeyPress={this.handleEnterEvent}
                      // onChange={onSearchClick}
                      //  onChange={(e) => {
                      //   onSearchClick(e);
                      //  }}
                      value={this.state.key}
                      endAdornment={this.endAdornment()}
                    />
                  </Paper>
                </div>
              </FormControl>
            </Grid>
            {/* <Grid item xs={6} md={2}>
                    <FormControl className="form-width-70 margin-t-b-20 margin-p-b-20" style={{ margin: 20 }}>

                      <FormLabel id="demo-radio-buttons-group-label" style={{ color: '#424242' }}>SALE STATUS</FormLabel>
                      <div  >

                        <FormControlLabel
                          control={
                            <Checkbox
                              name="checkedB1"
                              value={this.state.notforSale}
                              checked={this.state.notforSale}
                              className="float-right"
                              onChange={this.handleNotforSaleCheck}
                            />
                          }
                          label="Not for sale"
                        />

                      </div>
                    </FormControl>
                  </Grid> */}
            {this.state.filterEnable && (
              <>
                <Grid item xs={12} sm={12} md={3}>
                  <span onClick={this.removetype} style={{ float: "right" }}>
                    <Icon
                      className={this.state.type ? "fa fa-times-circle" : ""}
                    />
                  </span>
                  <FormControl variant="outlined" className="formControl">
                    <InputLabel
                      id="demo-simple-select-outlined-label"
                      className="font-14"
                    >
                      Type
                    </InputLabel>
                    <Select
                      style={{ color: "black" }}
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      onChange={(e) => {
                        if (e.target.value !== "misc_product") {
                          this.setState({
                            type: e.target.value,
                            InventoryCategory: "",
                            appliedFilterName: "",
                          });
                        } else {
                          this.setState({
                            type: e.target.value,
                            appliedFilterName: "",
                          });
                        }
                        setTimeout(() => {
                          this.SearchInventoryWatchesdetails();
                        }, 1000);
                      }}
                      label="Brand"
                      value={this.state.type}
                    >
                      <MenuItem value="ALL">All</MenuItem>
                      <MenuItem value="standand_and_misc">
                        Standard and Misc Watch
                      </MenuItem>
                      <MenuItem value="standard_watch">Standard Watch</MenuItem>
                      <MenuItem value="misc_watch">Misc Watch</MenuItem>
                      <MenuItem value="misc_product">Misc Product</MenuItem>
                    </Select>
                  </FormControl>
                  {/* <Typography
                      variant="h6"
                      className="color-383838"
                      style={{ fontSize: "15px" }}
                    >
                      {this.state.type}
                    </Typography> */}
                </Grid>

                <Grid item xs={12} sm={12} md={3}>
                  <span
                    onClick={this.removeInventoryCategory}
                    style={{ float: "right" }}
                  >
                    <Icon
                      className={
                        this.state.InventoryCategory ? "fa fa-times-circle" : ""
                      }
                    />
                  </span>
                  <FormControl variant="outlined" className="formControl">
                    <InputLabel
                      id="demo-simple-select-outlined-label"
                      className="font-14"
                    >
                      Category
                    </InputLabel>
                    <Select
                      style={{
                        color:
                          this.state.type !== "misc_product" ? "#bbb" : "black",
                        background:
                          this.state.type !== "misc_product" ? "#ccc" : "#fff",
                      }}
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      label="Inventory Category"
                      defaultValue={this.state.InventoryCategory}
                      value={this.state.InventoryCategory}
                      disabled={this.state.type !== "misc_product"}
                      onChange={(e) => {
                        this.setState({
                          InventoryCategory: e.target.value,
                          appliedFilterName: "",
                        });
                        setTimeout(() => {
                          this.SearchInventoryWatchesdetails();
                        }, 1000);
                      }}
                    >
                      <MenuItem value="ALL">All</MenuItem>
                      <MenuItem value="watch related accessories">
                        Watch Related Accessories
                      </MenuItem>
                      <MenuItem value="apparel">Apparel</MenuItem>
                      <MenuItem value="watch parts">Watch Part (s)</MenuItem>
                      <MenuItem value="jewelry">Jewelry</MenuItem>
                      <MenuItem value="stones">Stones</MenuItem>
                      {/* <MenuItem value="stones">Gem (s)</MenuItem> */}
                      <MenuItem value="hand bags">Hand Bags</MenuItem>
                      <MenuItem value="wallets">Wallets</MenuItem>
                      <MenuItem value="bag related accessories">
                        Bag Related Accessories
                      </MenuItem>
                      <MenuItem value="service watches">
                        Service Watches
                      </MenuItem>
                      <MenuItem value="others">Others</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={3}>
                  <span
                    onClick={this.removeInventoryStatus}
                    style={{ float: "right" }}
                  >
                    <Icon
                      className={
                        this.state.InventoryStatus ? "fa fa-times-circle" : ""
                      }
                    />
                  </span>
                  <FormControl variant="outlined" className="formControl">
                    <InputLabel
                      id="demo-simple-select-outlined-label"
                      className="font-14"
                    >
                      Inventory Status
                    </InputLabel>
                    <Select
                      style={{ color: "black" }}
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      label="Inventory Status"
                      defaultValue={this.state.InventoryStatus}
                      value={this.state.InventoryStatus}
                      onChange={(e) => {
                        this.setState({
                          InventoryStatus: e.target.value,
                          appliedFilterName: "",
                        });
                        setTimeout(() => {
                          this.SearchInventoryWatchesdetails();
                        }, 1000);
                      }}
                    >
                      <MenuItem value="2">Incoming</MenuItem>
                      <MenuItem value="6">Needs Service / Polish</MenuItem>
                      <MenuItem value="7">At Service</MenuItem>
                      <MenuItem value="11">Intake Complete</MenuItem>
                      <MenuItem value="13">Need to Post</MenuItem>
                      <MenuItem value="12">Invoiced</MenuItem>
                      <MenuItem value="1">Inhand</MenuItem>
                      <MenuItem value="3">Out on Memo</MenuItem>
                      <MenuItem value="4">On Hold / Reserved</MenuItem>
                      <MenuItem value="8">Need to Ship</MenuItem>
                      <MenuItem value="9">Shipped waiting on payment</MenuItem>
                      <MenuItem value="10">Sold & Cashed Out</MenuItem>
                      <MenuItem value="5">Available to Order</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={3}>
                  <span
                    onClick={this.removeInventoryType}
                    style={{ float: "right" }}
                  >
                    <Icon
                      className={
                        this.state.InventoryType ? "fa fa-times-circle" : ""
                      }
                    />
                  </span>

                  <FormControl variant="outlined" className="formControl">
                    <InputLabel
                      id="demo-simple-select-outlined-label"
                      className="font-14"
                    >
                      Inventory Type
                    </InputLabel>
                    <Select
                      style={{ color: "black" }}
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      label="Inventory Type"
                      defaultValue={this.state.InventoryType}
                      value={this.state.InventoryType}
                      onChange={(e) => {
                        this.setState({
                          InventoryType: e.target.value,
                          appliedFilterName: "",
                        });
                        setTimeout(() => {
                          this.SearchInventoryWatchesdetails();
                        }, 1000);
                      }}
                    >
                      <MenuItem value="ALL">All</MenuItem>
                      <MenuItem value="1">Regular Inventory</MenuItem>
                      <MenuItem value="2">Memo Inventory</MenuItem>
                      <MenuItem value="3">Partnership Inventory</MenuItem>
                      <MenuItem value="4">Trade Inventory</MenuItem>
                      <MenuItem value="5">Consignment Inventory</MenuItem>
                      <MenuItem value="NULL">
                        <i>Not Assigned </i>
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box
                    component="fieldset"
                    borderColor="transparent"
                    className="padding-0 "
                    // style={{ margin: "20px 0px" }}
                    style={{ marginTop: "20px" }}
                  >
                    <InputLabel
                      htmlFor="component-simple"
                      style={{ color: "#424242", marginBottom: "45px" }}
                    >
                      Inventory Age
                    </InputLabel>
                    <FormControl className="form-width-100 sliderclass">
                      <MuiSlider
                        value={this.state.purchasedate}
                        aria-labelledby="discrete-slider-always"
                        getAriaValueText={this.valueLabelFormat}
                        valueLabelFormat={this.valueLabelFormat}
                        valueLabelDisplay="on"
                        step={1}
                        marks={followersMarks1}
                        min={0}
                        max={220}
                        onChange={(event, value) => {
                          this.inventoryPurchaseDateInterval(value);
                        }}
                        onChangeCommitted={(event, value) => {
                          this.SearchInventoryWatchesdetails();
                        }}
                        onMouseUp={(event) => {
                          setTimeout(() => {
                            this.SearchInventoryWatchesdetails();
                          }, 1000);
                        }}
                        className="MuiOutlinedInput"
                        ariaLabelledBy="non-linear-slider"
                      />
                      <FormHelperText className="color-BCBCBC">
                        (Ex: 15 days, Purchase date is greater than or equal to
                        15 days )
                      </FormHelperText>
                    </FormControl>
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box
                    component="fieldset"
                    borderColor="transparent"
                    className="padding-0 "
                    // style={{ margin: "20px 0px" }}
                    style={{ marginTop: "20px" }}
                  >
                    <InputLabel
                      htmlFor="component-simple"
                      style={{ color: "#424242", marginBottom: "45px" }}
                    >
                      {getCustomLabel("custom_end_customer_price", "Target End Customer Price")}
                    </InputLabel>
                    <FormControl className="form-width-100 sliderclass">
                      {/* <Typography
                style={{
                  textAlign: "right",
                  marginTop: "-20px",
                  visibility: "hidden",
                }}
              >
                {" "}
                {2}
              </Typography> */}

                      <MuiSlider
                        value={this.state.priceRange}
                        aria-labelledby="discrete-slider-always"
                        getAriaValueText={this.valuePriceRangeFormat}
                        // valueLabelFormat={this.valuePriceRangeFormat}
                        valueLabelDisplay="on"
                        step={5}
                        marks={PriceRangeObj}
                        min={0}
                        max={100001}
                        onChange={(event, value) => {
                          this.inventoryPriceRangeInterval(value);
                        }}
                        onChangeCommitted={(event) => {
                          this.SearchInventoryWatchesdetails();
                        }}
                        // classes={{valueLabelLabel}}
                        //className="MuiOutlinedInput"
                        ariaLabelledBy="non-linear-slider"
                      />
                    </FormControl>
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={3}
                  style={{ marginBottom: "15px" }}
                >
                  <span
                    onClick={this.removeImageType}
                    style={{ float: "right" }}
                  >
                    <Icon
                      className={
                        this.state.productImage ? "fa fa-times-circle" : ""
                      }
                    />
                  </span>
                  <FormControl variant="outlined" className="formControl">
                    <InputLabel
                      id="demo-simple-select-outlined-label"
                      className="font-14"
                    >
                      Image Type
                    </InputLabel>
                    <Select
                      style={{ color: "black" }}
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      label="Inventory Type"
                      value={this.state.productImage}
                      onChange={(e) => {
                        this.setState({
                          productImage: e.target.value,
                          appliedFilterName: "",
                        });
                        setTimeout(() => {
                          this.SearchInventoryWatchesdetails();
                        }, 1000);
                      }}
                    >
                      <MenuItem value="ALL">All</MenuItem>
                      <MenuItem value="with_image">With Image</MenuItem>
                      <MenuItem value="without_image">Without Image</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={3}>
                  <span style={{ float: "right" }}>
                    <Icon />
                  </span>
                  <FormControl variant="outlined" className="formControl">
                    <Autocomplete
                      multiple
                      name="contactType"
                      limitTags={1}
                      options={ContactTypeOptions}
                      renderOption={(option, { selected }) => (
                        <React.Fragment>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            checked={selected}
                          />
                          {option.value}
                        </React.Fragment>
                      )}
                      getOptionLabel={(option) =>
                        option?.value ? option.value : ""
                      }
                      getOptionSelected={(option, value) =>
                        option?.id === value?.id
                      }
                      value={
                        this.state.contactType.map((id) =>
                          ContactTypeOptions.find((option) => option.id === id),
                        ) || []
                      }
                      onChange={this.handleAutoComplete}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label="Contact Type"
                          InputLabelProps={{
                            className: "font-14",
                          }}
                          InputProps={{
                            ...params.InputProps,
                            classes: {
                              input: classes.customInput,
                            },
                          }}
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={3}>
                  <span style={{ float: "right" }}>
                    <Icon />
                  </span>
                  <FormControl
                    className="form-width-99"
                    onSubmit={(e) => {
                      e.preventDefault();
                      this.SearchInventoryWatchesdetails();
                    }}
                  >
                    <div style={{ marginBottom: "10px" }}>
                      <Paper style={{ height: "55px", display: "flex" }}>
                        <InputBase
                          fullWidth
                          sx={{ ml: 3, flex: 1 }}
                          inputProps={{
                            "aria-label": "Enter Contact Name",
                          }}
                          placeholder="Enter Contact Name"
                          onChange={(e) =>
                            this.setState({
                              contactName: e.target.value,
                              appliedFilterName: "",
                            })
                          }
                          onKeyPress={this.handleEnterEvent}
                          value={this.state.contactName}
                          endAdornment={this.contactNameAdornment()}
                        />
                      </Paper>
                    </div>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={3}>
                  <span style={{ float: "right" }}>
                    <Icon />
                  </span>
                  <FormControl variant="outlined" className="formControl">
                    <Autocomplete
                      name="locationType"
                      limitTags={1}
                      options={this.state.locationAutoCompleteData || []}
                      getOptionLabel={(option) => option?.locations || ""}
                      value={this.state.locationSearch}
                      onChange={(event, newValue) =>
                        this.handleLocationSearch(newValue)
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label="Inventory Location"
                          InputLabelProps={{
                            className: "font-14",
                          }}
                          InputProps={{
                            ...params.InputProps,
                            classes: {
                              input: classes.customInput,
                            },
                          }}
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
              </>
            )}
            {this.state.loaded ? (
              <>
                <Grid item xs={12} md={6}>
                  <Box
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    mb={2}
                  >
                    <Typography variant="h6"># of Items : </Typography>&nbsp;
                    <Typography variant="h6">
                      {" "}
                      {noOfItemsInventory ?? 0}{" "}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  {userData?.roleId == "2" ||
                    userData?.roleId == "3" ||
                    userData?.roleId == "6" ? (
                    <Box
                      display="flex"
                      flexDirection="row"
                      alignItems="center"
                      justifyContent={{ xs: "flex-start", md: "end" }}
                      mb={2}
                    >
                      <Typography variant="h6">Total Cost : </Typography>&nbsp;
                      <Typography variant="h6">
                        {" "}
                        ${" "}
                        {totalCostforInventory?.toLocaleString("en-US") ??
                          0}{" "}
                      </Typography>
                    </Box>
                  ) : null}
                </Grid>
              </>
            ) : null}

            {inventoryList && inventoryList.length > 0 && this.state.loaded && (
              <>
                {
                  <Grid
                    item
                    xs={12}
                    md={4}
                    style={{
                      padding: "10px 0",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Checkbox
                      style={{ padding: "0 5px" }}
                      checked={selectAll}
                      onChange={(e) =>
                        this.handleSelectAllChange(e, inventoryList)
                      }
                    />
                    <Typography
                      variant="p"
                      className="text-capitalize"
                      style={{ fontWeight: 600 }}
                    >
                      Select All{" "}
                      {`(# Items selected : ${(selectAll
                          ? noOfItemsInventory
                          : selectedItems.length) ?? 0
                        })`}
                    </Typography>
                  </Grid>
                }
                {selectedItems && selectedItems.length > 0 && (
                  <Grid
                    item
                    xs={12}
                    md={8}
                    style={{
                      padding: "0 10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      gap: "10px",
                    }}
                  >
                    {this.state.isShopifyEnabled &&
                      this.state.isShopifyVerified &&
                      soldStatus === "0" && (
                        <Button
                          id="demo-customized-button"
                          aria-haspopup="true"
                          variant="contained"
                          disableElevation
                          className="text-capitalize primary-bg color-white"
                          onClick={this.sendToShopifyInventory}
                          startIcon={<CachedIcon />}
                        >
                          Sync to Shopify
                        </Button>
                      )}
                    {this.state.isEbayEnabled && 
                     this.state.isEbayVerified && soldStatus === "0" && (
                      <Button
                        id="demo-customized-button"
                        aria-haspopup="true"
                        variant="contained"
                        disableElevation
                        className="primary-bg color-white"
                        style={{ textTransform: "none" }}
                        onClick={this.sendToEbayInventory}
                        startIcon={<CachedIcon />}
                      >
                        Sync to eBay
                      </Button>
                    )}
                    <Button
                      id="demo-customized-button"
                      aria-haspopup="true"
                      variant="contained"
                      disableElevation
                      className="text-capitalize primary-bg color-white"
                      onClick={this.handleOpenGenerateLabelDialog}
                    >
                      Generate Label
                    </Button>
                    {this.props?.InventoryList?.data?.length > 0 &&
                      soldStatus === "0" &&
                      userData?.accountName ? (
                      userData?.roleId === 2 ||
                        userData?.roleId === 3 ||
                        userData?.roleId === 6 ? (
                        <>
                          <Button
                            id="demo-customized-button"
                            aria-haspopup="true"
                            variant="contained"
                            disableElevation
                            className="text-capitalize primary-bg color-white"
                            onClick={() =>
                              this.setState({ openShareModal: true })
                            }
                          >
                            <Share />
                            &nbsp;Share
                          </Button>

                          <Button
                            id="demo-customized-button"
                            aria-haspopup="true"
                            variant="contained"
                            disableElevation
                            className="text-capitalize primary-bg color-white"
                            onClick={() =>
                              this.setState({ openDeleteModal: true })
                            }
                          >
                            Delete
                          </Button>
                        </>
                      ) : null
                    ) : null}
                  </Grid>
                )}
              </>
            )}
          </Grid>
          <br />
          {!this.state.loaded ? (
            <div className="d-spinner">
              <SpinnerRoundFilled
                size={51}
                thickness={125}
                speed={80}
                color="rgba(57, 107, 172, 1)"
                className="spp"
                enabled={!this.state.loaded}
              />
            </div>
          ) : (
            <InfiniteScroll
              style={{ overflow: "hidden" }}
              dataLength={inventoryList?.length || 0}
              next={() => this.fetchMoreData(inventoryList)}
              hasMore={this.state.hasMore && !this.state.loadingMore}
              loader={
                this.state.loadingMore ? (
                  <div style={{ margin: "25px auto", width: "100px" }}>
                    <Loader
                      type="Puff"
                      color="#9F7C50"
                      height={50}
                      width={50}
                    />
                    <div style={{ marginLeft: "-10px" }}>
                      <h4 className="color-p">Loading....</h4>
                    </div>
                  </div>
                ) : null
              }
            // endMessage={
            //   <p style={{ textAlign: "center" }}>
            //     <b>Yay! You have seen it all</b>
            //   </p>
            // }
            >
              {/* {this.state.loaded && ( */}
              <Grid container spacing={1}>
                {this.state.inventoryData &&
                  this.state.inventoryData.length > 0 &&
                  this.state.inventoryxlid &&
                  this.state.inventoryxlid !== "ALL" && (
                    <div style={{ margin: "auto", width: "100%" }}>
                      <Container style={{ marginBottom: "30px" }}>
                        <MaterialTable
                          title={`Bulk Upload Summary`}
                          data={this.state.inventoryData}
                          columns={[
                            { field: "status", title: "STATUS" },
                            {
                              field: "filePath",
                              title: "DOWNLOAD FILE",
                              render: (rowData) => (
                                <Link
                                  href={`${rowData.filePath}`}
                                  target="_blank"
                                >
                                  {rowData.filePath}
                                </Link>
                              ),
                            },
                          ]}
                        />
                      </Container>
                    </div>
                  )}
                {/* {inventoryList &&
                inventoryList.length === 0 &&
                !this.state.loaded ? (
                <Container style={{ marginBottom: "30px" }}>
                  <Typography
                    variant="body2"
                    className="textSecondary color-292C2F"
                    component="p"
                    align="center"
                  >
                    <b>No Watches Added Here!</b>
                  </Typography>
                </Container>
              ) : (
                ""
              )} */}
                {/* {inventoryList && inventoryList
                   .slice(
                     this.state.page * this.state.rowsPerPage,
                     this.state.page * this.state.rowsPerPage +
                     this.state.rowsPerPage
                   ) */}
                {inventoryList &&
                  inventoryList.length > 0 &&
                  inventoryList.map((row) => {
                    const imageSource =
                      row?.imagepaths?.front ||
                      row?.imagepaths?.back ||
                      row?.imagepaths?.left ||
                      row?.imagepaths?.right ||
                      row?.imagepaths?.wrist_shot ||
                      row?.imagepaths?.buckle_closed ||
                      row?.imagepaths?.buckle_opened ||
                      row?.imagepaths?.free_form;
                    const tooltipText =
                      row.sold === 1
                        ? `${this.state.soldText} ${row.sold_unsold_reason}`
                        : `${this.state.unsoldText} ${row.sold_unsold_reason}`;
                    const videoSource = row?.imagepaths?.video;
                    return (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={6}
                        className="inventory-card-container"
                        key={row.inventoryid}
                        onMouseEnter={() =>
                          this.handleMouseEnter(row.inventoryid)
                        }
                        onMouseLeave={() => this.handleMouseLeave}
                      >
                        <Card
                          className="inventrybox inventory-card"
                          style={{
                            cursor: "pointer",
                            //   boxShadow: '0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)',
                            "&:hover": {
                              boxShadow:
                                "0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)",
                            },
                            // position: row?.is_notsale ? 'relative' : '',
                            background:
                              row.type &&
                                (row.type === "misc_watch" ||
                                  row.type === "misc_product")
                                ? "antiquewhite"
                                : "white",
                            paddingTop: "20px",
                            paddingBottom: "20px",
                          }}
                        //   onClick={() =>this.handleChangeOfInventoryDetailById(row.inventoryid)}
                        >
                          {/* {row.is_notsale && <div
                              style={{

                                position: 'relative',
                                top: '80px',
                                left: '20px',
                                padding: '4px 45px',
                                transform: 'rotate(45deg)',
                                transformOrigin: 'top right',
                                color: 'white',
                                boxShadow: 'rgba(0, 0, 0, 0.16) 0px 3px 6px',
                                textShadow: 'rgba(0, 0, 0, 0.6) 1px 1px 2px',
                                textAlign: 'end',
                                background: 'red',
                              }}>Not for Sale</div>} */}
                          <Grid container spacing={2}>
                            <Grid
                              item
                              xs={1}
                              sm={1}
                              md={1}
                              style={{ padding: "0 15px" }}
                            >
                              {(hoveredCard === row.inventoryid ||
                                selectedItems.includes(row.inventoryid)) && (
                                  <Checkbox
                                    key={row.inventoryid}
                                    checked={selectedItems.includes(
                                      row.inventoryid,
                                    )}
                                    onChange={() =>
                                      this.handleCheckboxChange(row.inventoryid)
                                    }
                                  />
                                )}
                            </Grid>
                            <Grid
                              item
                              xs={row.voidreason ? 10 : 11}
                              sm={row.voidreason ? 10 : 11}
                              md={row.voidreason ? 10 : 11}
                              style={{ padding: "10px 15px" }}
                            >
                              <div
                                onClick={() =>
                                  this.handleChangeOfInventoryDetailById(
                                    row.inventoryid,
                                    row.invoiceid,
                                  )
                                }
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  textAlign: "center",
                                }}
                              >
                                <Typography
                                  variant="subtitle2"
                                  className="textSecondary color-292C2 MuiTypography-textupper"
                                  component="p"
                                // style={{ height: '28px', textAlign: "center", display: "block", marginTop: "10px", paddingBottom: "0px" }}
                                >
                                  <b>
                                    {row.type === "misc_watch" ||
                                      row.type === "misc_product"
                                      ? row?.technical_details?.product_title
                                        ? row?.technical_details?.product_title
                                          : row?.inventory_title
                                      : row?.inventory_title}
                                  </b>
                                </Typography>
                                {row.status && row.status === "Void" ? (
                                  <Chip
                                    className="void-status"
                                    size="small"
                                    label={"Void"}
                                    style={{ marginLeft: "10px" }}
                                  />
                                ) : null}
                              </div>
                            </Grid>
                            {row.voidreason ? (
                              <Grid
                                item
                                xs={1}
                                sm={1}
                                md={1}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  paddingLeft: 0,
                                }}
                              >
                                {row.status && row.status === "Void" ? (
                                  <Tooltip
                                    placement="bottom"
                                    arrow
                                    slotProps={{
                                      tooltip: {
                                        sx: {
                                          backgroundColor: "black",
                                          color: "white",
                                          fontSize: 14,
                                          padding: "8px 12px",
                                          borderRadius: "6px",
                                        },
                                      },
                                      arrow: {
                                        sx: {
                                          color: "black",
                                        },
                                      },
                                    }}
                                    title={
                                      <div>
                                        <div>
                                          <span style={{ fontWeight: "bold" }}>
                                            Void Reason:
                                          </span>{" "}
                                          {row.voidreason || "-"}
                                        </div>

                                        {row.purchase_voidreason && (
                                          <div style={{ marginTop: "8px" }}>
                                            <span
                                              style={{ fontWeight: "bold" }}
                                            >
                                              Skip Additional Cost Reason:
                                            </span>{" "}
                                            {row.purchase_voidreason}
                                          </div>
                                        )}
                                      </div>
                                    }
                                  >
                                    <InfoOutlinedIcon />
                                  </Tooltip>
                                ) : null}
                              </Grid>
                            ) : (
                              <></>
                            )}
                            <Grid
                              item
                              xs={12}
                              sm={4}
                              md={4}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                paddingTop: "0px",
                              }}
                            >
                              <div
                                className="text-center1"
                                style={{
                                  paddingLeft: "30px",
                                }}
                              >
                                {imageSource ? (
                                  row.sold_unsold_reason ? (
                                    <Tooltip
                                      title={tooltipText}
                                      placement="right"
                                    >
                                      <img
                                        src={imageSource}
                                        alt="rolex"
                                        className="img-responsive1 inventry-img"
                                        onClick={() =>
                                          this.handleChangeOfInventoryDetailById(
                                            row.inventoryid,
                                            row.invoiceid,
                                          )
                                        }
                                      />
                                    </Tooltip>
                                  ) : (
                                    <img
                                      src={imageSource}
                                      alt="rolex"
                                      className="img-responsive1 inventry-img"
                                      onClick={() =>
                                        this.handleChangeOfInventoryDetailById(
                                          row.inventoryid,
                                          row.invoiceid,
                                        )
                                      }
                                    />
                                  )
                                ) : videoSource ? (
                                  <VideoPlayer
                                    videoUrl={videoSource + "?autoplay=1"}
                                    snapshotAt={10}
                                  />
                                ) : (
                                  <img
                                    src={
                                      row?.product_imagepaths?.images?.[0] ||
                                      imageNotAvailable
                                    }
                                    alt="rolex"
                                    className="img-responsive1 inventry-img"
                                    onClick={() =>
                                      this.handleChangeOfInventoryDetailById(
                                        row.inventoryid,
                                        row.invoiceid,
                                      )
                                    }
                                  />
                                )}
                                {this.state.setting &&
                                  this.state.setting?.manufacturer_price &&
                                  !["misc_watch", "misc_product"].includes(
                                    (row?.type || "").toLowerCase(),
                                  ) && (
                                    <div
                                      style={{
                                        marginTop: 10,
                                        fontSize: "14px",
                                      }}
                                    >
                                      <Typography>
                                        Last Updated <span>MSRP</span>
                                      </Typography>
                                      {(() => {
                                        const lastupdateddate =
                                          row?.lastupdatedate;

                                        const isValidDate = (d) =>
                                          d &&
                                          d !== "NA" &&
                                          d.toString().trim() !== "" &&
                                          !isNaN(new Date(d));

                                        if (!isValidDate(lastupdateddate))
                                          return null;

                                        const dateObj = new Date(
                                          lastupdateddate,
                                        );
                                        const month = dateObj.toLocaleString(
                                          "en-US",
                                          { month: "short" },
                                        );
                                        const year = dateObj.getFullYear();

                                        return (
                                          <Typography className="msrp-date">
                                            (As per {month}, {year})
                                          </Typography>
                                        );
                                      })()}
                                      <Typography>
                                        {row?.manufactureprice &&
                                          row?.manufactureprice !== "0.00"
                                          ? `$ ${row.manufactureprice}`
                                          : "NA"}
                                      </Typography>
                                    </div>
                                  )}
                              </div>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={8}
                              md={8}
                              style={{ paddingTop: "0px" }}
                            >
                              <div className="space-1 text-center1">
                                <Grid container spacing={2}>
                                  {/* <Grid item xs={12} sm={12} md={12}>
                                      <div
                                        onClick={() =>
                                          this.handleChangeOfInventoryDetailById(
                                            row.inventoryid
                                          )
                                        }
                                      >
                                        <Typography
                                          variant="subtitle2"
                                          className="textSecondary color-292C2 MuiTypography-textupper"
                                          component="p"
                                        style={{height:'50px'}}
                                        >
                                          <b>{row?.inventory_title}</b>
                                        </Typography>
                                      </div>
                                    </Grid> */}
                                  <Grid item xs={12} sm={12} md={12}>
                                    <div
                                      onClick={() =>
                                        this.handleChangeOfInventoryDetailById(
                                          row.inventoryid,
                                          row.invoiceid,
                                        )
                                      }
                                    >
                                      {row.type !== "misc_product" && (
                                        <>
                                          {this.state.setting &&
                                            this.state.setting.brandname && (
                                              <>
                                                <Typography
                                                  variant="p"
                                                  className="inventory-tile"
                                                  style={{
                                                    height: "auto",
                                                    paddingBottom: "4px",
                                                  }}
                                                >
                                                  Brand :{" "}
                                                  {row.type === "misc_watch" ||
                                                    row.type === "misc_product"
                                                    ? row?.technical_details
                                                      ?.brand_name
                                                      ? row?.technical_details
                                                        ?.brand_name
                                                      : "--"
                                                    : row?.brandname
                                                      ? row?.brandname
                                                      : "--"}
                                                </Typography>
                                              </>
                                            )}
                                          {this.state.setting &&
                                            this.state.setting.reference && (
                                              <>
                                                <Typography
                                                  variant="p"
                                                  className="inventory-tile"
                                                  style={{
                                                    height: "auto",
                                                    paddingBottom: "4px",
                                                  }}
                                                >
                                                  Ref # :{" "}
                                                  {row?.prodattr?.reference ??
                                                    row?.technical_details
                                                      ?.model_number ??
                                                    "--"}
                                                </Typography>
                                              </>
                                            )}
                                          {this.state.setting &&
                                            this.state.setting.dialcolor && (
                                              <>
                                                <Typography
                                                  variant="p"
                                                  className="inventory-tile"
                                                >
                                                  Dial Color :{" "}
                                                  {row?.technical_details
                                                    ?.dial_color
                                                    ? row?.technical_details
                                                      ?.dial_color
                                                    : row?.prodattr?.dialcolor
                                                      ? row?.prodattr?.dialcolor
                                                      : "--"}
                                                </Typography>
                                                <br />
                                              </>
                                            )}
                                          {this.state.setting &&
                                            this.state.setting.box && (
                                              <>
                                                <Typography
                                                  variant="p"
                                                  className="inventory-tile"
                                                >
                                                  Box :{" "}
                                                  {row?.warrantybox &&
                                                    row.warrantybox === "1"
                                                    ? "Yes"
                                                    : "No"}
                                                </Typography>
                                                <br />
                                              </>
                                            )}
                                          {this.state.setting &&
                                            this.state.setting.warranty && (
                                              <>
                                                <Typography
                                                  variant="p"
                                                  className="inventory-tile"
                                                >
                                                  Warranty :{" "}
                                                  {row.warrantypaper
                                                    ? "Yes"
                                                    : "No"}
                                                </Typography>
                                                <br />
                                                <Typography
                                                  variant="p"
                                                  className="inventory-tile"
                                                >
                                                  Warranty Year :{" "}
                                                  {/* {row?.warrantydate ? moment(row?.warrantydate).format("YYYY") : "-"} */}
                                                  {row?.warrantydate
                                                    ? formatDate(
                                                      row?.warrantydate,
                                                      "YYYY",
                                                    )
                                                    : "--"}
                                                </Typography>
                                                <br />
                                              </>
                                            )}
                                          {this.state.setting &&
                                            this.state.setting.condition && (
                                              <>
                                                <Typography
                                                  variant="p"
                                                  className="inventory-tile"
                                                >
                                                  Condition :{" "}
                                                  {row.condition &&
                                                    row.condition === 4
                                                    ? getNewCond()
                                                    : row.condition &&
                                                      row.condition === 3
                                                      ? getRetailReady()
                                                      : row.condition &&
                                                        row.condition === 2
                                                        ? getMintVeryGood()
                                                        : getUsedGood()}
                                                </Typography>
                                                <br />
                                              </>
                                            )}
                                          {/* {row.targetwholesaleprice && (
                                              <>
                                                <Typography variant="p" className="inventory-tile">
                                                  Target Wholesale Price:{" "}
                                                  $ {row.targetwholesaleprice}
                                                </Typography>
                                                <br />
                                              </>
                                            )} */}
                                          {this.state.setting &&
                                            this.state.setting
                                              .inventorystatus && (
                                              <>
                                                <Typography
                                                  variant="p"
                                                  className="inventory-tile"
                                                >
                                                  Inventory Status :{" "}
                                                  {row?.inventory_status
                                                    ? renderInventoryStatusLabel(
                                                      row.inventory_status,
                                                      InventoryStatusLookup)
                                                    : "--"}
                                                </Typography>
                                                <br />
                                              </>
                                            )}
                                          {this.state.setting &&
                                            this.state.setting.locations && (
                                              <>
                                                <Typography
                                                  variant="p"
                                                  className="inventory-tile"
                                                >
                                                  Inventory Location :{" "}
                                                  {row?.locations
                                                    ? row?.locations
                                                    : "--"}
                                                </Typography>
                                                <br />
                                              </>
                                            )}{" "}
                                          <>
                                            <Typography
                                              variant="p"
                                              className="inventory-tile"
                                            >
                                              Inventory ID :{" "}
                                              {row?.inventoryid
                                                ? row?.inventoryid
                                                : "--"}
                                            </Typography>
                                            <br />
                                          </>
                                          {this.state.setting &&
                                            this.state.setting
                                              .wholesaleprice && (
                                              <>
                                                <>
                                                  <Typography
                                                    variant="p"
                                                    className="inventory-tile1"
                                                  >
                                                    {getCustomLabel("custom_wholesale_price", "Target Wholesale Price")} :{" "}
                                                    {row?.targetwholesaleprice
                                                      ? "$" +
                                                      row?.targetwholesaleprice
                                                      : "--"}
                                                  </Typography>

                                                </>
                                              </>
                                            )}
                                          {this.state.setting &&
                                            this.state.setting
                                              .enccustomerprice && (
                                              <>
                                                <Typography
                                                  variant="p"
                                                  className="inventory-tile1"
                                                >
                                                  {getCustomLabel("custom_end_customer_price", "Target End Customer Price")} :{" "}
                                                  {row?.targetendcustomerprice
                                                    ? "$" +
                                                    row?.targetendcustomerprice
                                                    : "--"}
                                                </Typography>

                                              </>
                                            )}
                                          {this.state.setting &&
                                            this.state.setting.tagprice && (
                                              <>
                                                <Typography
                                                  variant="p"
                                                  className="inventory-tile1"
                                                >
                                                  {getCustomLabel("custom_tag_price", "Tag Price")} :{" "}
                                                  {row?.tag_price
                                                    ? "$" + row?.tag_price
                                                    : "--"}
                                                </Typography>

                                              </>
                                            )}
                                          {this.state.setting &&
                                            this.state.setting
                                              .purchase_payment_status && (
                                              <>
                                                <Typography
                                                  variant="p"
                                                  className="inventory-tile"
                                                  style={{ display: "flex" }}
                                                >
                                                  Purchase Payment Status :{" "}
                                                  <div
                                                    style={{ marginLeft: 2 }}
                                                  >
                                                    {
                                                      row?.purchase_invoice_paid
                                                        ? "Paid"
                                                        : "Not Paid"
                                                      //  <CancelSharpIcon sx={{color:'red'}}/>
                                                    }
                                                  </div>
                                                </Typography>
                                                <br />
                                              </>
                                            )}
                                          {row?.purchase_invoice_paid ? (
                                            this.state.setting
                                              .purchase_payment_date ? (
                                              <>
                                                <Typography
                                                  variant="p"
                                                  className="inventory-tile"
                                                >
                                                  Purchase Payment Date :{" "}
                                                  {/* {row?.purchase_payment_date ? moment(row?.purchase_payment_date).format('MM/DD/YYYY') : '--'} */}
                                                  {row?.purchase_payment_date
                                                    ? formatDate(
                                                      row?.purchase_payment_date,
                                                      "MM/DD/YYYY",
                                                    )
                                                    : "--"}
                                                </Typography>
                                                <br />
                                              </>
                                            ) : null
                                          ) : this.state.setting
                                            .purchase_payment_date ? (
                                            <>
                                              <Typography
                                                variant="p"
                                                className="inventory-tile"
                                              >
                                                Purchase Payment Due Date :{" "}
                                                {/* {row?.purchase_payment_duedate ? moment(row?.purchase_payment_duedate).format('MM/DD/YYYY') : '--'} */}
                                                {row?.purchase_payment_duedate
                                                  ? formatDate(
                                                    row?.purchase_payment_duedate,
                                                    "MM/DD/YYYY",
                                                  )
                                                  : "--"}
                                              </Typography>
                                              <br />
                                            </>
                                          ) : null}
                                          {this.state.setting &&
                                            this.state.setting
                                              .purchase_payment_details && (
                                              <>
                                                <Typography
                                                  variant="p"
                                                  className="inventory-tile"
                                                  style={{ height: "auto" }}
                                                >
                                                  Purchase Payment Details :{" "}
                                                  {row?.purchase_payment_details
                                                    ? row?.purchase_payment_details
                                                    : "--"}
                                                </Typography>
                                                <br />
                                              </>
                                            )}
                                          {this.state.setting &&
                                            this.state.setting.totalcost &&
                                            this.state.userData?.roleId !== 8 &&
                                            this.state.userData?.roleId !== 9 &&
                                            this.state.userData?.roleId !==
                                            10 && (
                                              <>
                                                <Typography
                                                  variant="p"
                                                  className="inventory-tile"
                                                >
                                                  Total Cost :{" "}
                                                  {row?.total_cost
                                                    ? "$" + row?.total_cost
                                                    : "--"}
                                                </Typography>
                                                <br />
                                              </>
                                            )}
                                          {/* {row?.ebay_listing_id && (
                                            <>
                                              <Typography
                                                variant="p"
                                                className="inventory-tile"
                                                style={{ height: "auto" }}
                                              >
                                                Ebay Item Id : {row.ebay_listing_id}
                                              </Typography>
                                              <br />
                                            </>
                                          )} */}
                                        </>
                                      )}
                                      {row.type === "misc_product" && (
                                        <>
                                          {this.state.setting &&
                                            this.state.setting.productname && (
                                              <>
                                                <Typography
                                                  variant="p"
                                                  className="inventory-tile"
                                                  style={{
                                                    height: "auto",
                                                    paddingBottom: "4px",
                                                  }}
                                                >
                                                  Product Name:{" "}
                                                  {row &&
                                                    row?.technical_details
                                                      ?.product_name 
                                                    ? row?.technical_details
                                                      ?.product_name 
                                                    : "--"}
                                                </Typography>
                                              </>
                                            )}
                                          {this.state.setting &&
                                            this.state.setting.brandname && (
                                              <>
                                                <Typography
                                                  variant="p"
                                                  className="inventory-tile"
                                                  style={{
                                                    height: "auto",
                                                    paddingBottom: "4px",
                                                  }}
                                                >
                                                  Brand:{" "}
                                                  {row?.technical_details
                                                    ?.brand_name
                                                    ? row?.technical_details
                                                      ?.brand_name
                                                    : "--"}
                                                </Typography>
                                              </>
                                            )}
                                          {this.state.setting &&
                                            this.state.setting.reference && (
                                              <>
                                                <Typography
                                                  variant="p"
                                                  className="inventory-tile"
                                                  style={{
                                                    height: "auto",
                                                    paddingBottom: "4px",
                                                  }}
                                                >
                                                  Ref # :{" "}
                                                  {row?.prodattr?.reference ??
                                                    row?.technical_details
                                                      ?.model_number ??
                                                    "--"}
                                                </Typography>
                                              </>
                                            )}
                                          {this.state.setting &&
                                            this.state.setting.category && (
                                              <>
                                                <Typography
                                                  variant="p"
                                                  className="text-capitalize inventory-tile"
                                                >
                                                  Category:{" "}
                                                  {row && row.category
                                                    ? row.category
                                                    : "--"}
                                                </Typography>
                                                <br />
                                              </>
                                            )}
                                          {this.state.setting &&
                                            this.state.setting.condition && (
                                              <>
                                                <Typography
                                                  variant="p"
                                                  className="inventory-tile"
                                                >
                                                  Condition :{" "}
                                                  {/* {row.condition && row.condition === 1 ? 'New' :
                                                'Used'
                                              } */}
                                                  {row.condition == 2
                                                    ? getUsed()
                                                    : getNewCond()}
                                                </Typography>
                                                <br />
                                              </>
                                            )}
                                          {/* {row.targetwholesaleprice && (
                                              <>
                                                <Typography variant="p" className="inventory-tile">
                                                  Target Wholesale Price:{" "}
                                                  $ {row.targetwholesaleprice}
                                                </Typography>
                                                <br />
                                              </>
                                            )} */}
                                          {this.state.setting &&
                                            this.state.setting
                                              .inventorystatus && (
                                              <>
                                                <Typography
                                                  variant="p"
                                                  className="inventory-tile"
                                                >
                                                  Inventory Status :{" "}
                                                  {row?.inventory_status
                                                    ? renderInventoryStatusLabel(
                                                      row.inventory_status,
                                                      InventoryStatusLookup)
                                                    : "--"}
                                                </Typography>
                                                <br />
                                              </>
                                            )}
                                          <>
                                            {this.state.setting &&
                                              this.state.setting.locations && (
                                                <>
                                                  <Typography
                                                    variant="p"
                                                    className="inventory-tile"
                                                  >
                                                    Inventory Location :{" "}
                                                    {row?.locations
                                                      ? row?.locations
                                                      : "--"}
                                                  </Typography>
                                                  <br />
                                                </>
                                              )}
                                            <Typography
                                              variant="p"
                                              className="inventory-tile"
                                            >
                                              Inventory ID :{" "}
                                              {row?.inventoryid
                                                ? row?.inventoryid
                                                : "--"}
                                            </Typography>
                                            <br />
                                          </>
                                          {this.state.setting &&
                                            this.state.setting
                                              .wholesaleprice && (
                                              <>
                                                <Typography
                                                  variant="p"
                                                  className="inventory-tile"
                                                >
                                                  {getCustomLabel("custom_wholesale_price", "Target Wholesale Price")} :{" "}
                                                  {row?.targetwholesaleprice
                                                    ? "$" +
                                                    row?.targetwholesaleprice
                                                    : "--"}
                                                </Typography>
                                                <br />
                                              </>
                                            )}
                                          {this.state.setting &&
                                            this.state.setting
                                              .enccustomerprice && (
                                              <>
                                                <Typography
                                                  variant="p"
                                                  className="inventory-tile"
                                                >
                                                  {getCustomLabel("custom_end_customer_price", "Target End Customer Price")} :{" "}
                                                  {row?.targetendcustomerprice
                                                    ? "$" +
                                                    row?.targetendcustomerprice
                                                    : "--"}
                                                </Typography>
                                                <br />
                                              </>
                                            )}
                                          {this.state.setting &&
                                            this.state.setting.tagprice && (
                                              <>
                                                <Typography
                                                  variant="p"
                                                  className="inventory-tile"
                                                >
                                                  {getCustomLabel("custom_tag_price", "Tag Price")} :{" "}
                                                  {row?.tag_price
                                                    ? "$" + row?.tag_price
                                                    : "--"}
                                                </Typography>
                                                <br />
                                              </>
                                            )}

                                          {/* {this.state.setting && this.state.setting.sold_price && (
                                          <>
                                            <Typography
                                              variant="p"
                                              className="inventory-tile"
                                              style={{
                                                display: "inline-flex",
                                                alignItems: "center",
                                                gap: 6,
                                                backgroundColor: "#E7F5EC",
                                                color: "#0B8A4A",
                                                padding: "5px 10px",
                                                borderRadius: 8,
                                                fontWeight: 600,
                                              }}
                                            >
                                              Sold Price
                                              <span>{row?.sold_price ? "$ " + row?.sold_price : "--"}</span>
                                            </Typography>
                                            <br />
                                          </>)} */}
                                          {this.state.setting &&
                                            this.state.setting
                                              .purchase_payment_status && (
                                              <>
                                                <Typography
                                                  variant="p"
                                                  className="inventory-tile"
                                                >
                                                  Purchase Payment Status :{" "}
                                                  {row?.purchase_invoice_paid
                                                    ? "Paid"
                                                    : "Not Paid"}
                                                </Typography>
                                                <br />
                                              </>
                                            )}
                                          {row?.purchase_invoice_paid ? (
                                            this.state.setting
                                              .purchase_payment_date ? (
                                              <>
                                                <Typography
                                                  variant="p"
                                                  className="inventory-tile"
                                                >
                                                  Purchase Payment Date :{" "}
                                                  {/* {row?.purchase_payment_date ? moment(row?.purchase_payment_date).format('MM/DD/YYYY') : '--'} */}
                                                  {row?.purchase_payment_date
                                                    ? formatDate(
                                                      row?.purchase_payment_date,
                                                      "MM/DD/YYYY",
                                                    )
                                                    : "--"}
                                                </Typography>
                                                <br />
                                              </>
                                            ) : null
                                          ) : this.state.setting
                                            .purchase_payment_duedate ? (
                                            <>
                                              <Typography
                                                variant="p"
                                                className="inventory-tile"
                                              >
                                                Purchase Payment Due Date :{" "}
                                                {/* {row?.purchase_payment_duedate ? moment(row?.purchase_payment_duedate).format('MM/DD/YYYY') : '--'} */}
                                                {row?.purchase_payment_duedate
                                                  ? formatDate(
                                                    row?.purchase_payment_duedate,
                                                    "MM/DD/YYYY",
                                                  )
                                                  : "--"}
                                              </Typography>
                                              <br />
                                            </>
                                          ) : null}
                                          {this.state.setting &&
                                            this.state.setting
                                              .purchase_payment_details && (
                                              <>
                                                <Typography
                                                  variant="p"
                                                  className="inventory-tile"
                                                  style={{ height: "auto" }}
                                                >
                                                  Purchase Payment Details :{" "}
                                                  {row?.purchase_payment_details
                                                    ? row?.purchase_payment_details
                                                    : "--"}
                                                </Typography>
                                                <br />
                                              </>
                                            )}
                                          {this.state.setting &&
                                            this.state.setting.totalcost &&
                                            this.state.userData?.roleId !== 8 &&
                                            this.state.userData?.roleId !== 9 &&
                                            this.state.userData?.roleId !==
                                            10 && (
                                              <>
                                                <Typography
                                                  variant="p"
                                                  className="inventory-tile"
                                                >
                                                  Total Cost :{" "}
                                                  {row?.total_cost
                                                    ? "$" + row?.total_cost
                                                    : "--"}
                                                </Typography>
                                                <br />
                                              </>
                                            )}
                                          {/* {row?.ebay_listing_id && (
                                            <>
                                              <Typography
                                                variant="p"
                                                className="inventory-tile"
                                                style={{ height: "auto" }}
                                              >
                                                Ebay Item Id : {row.ebay_listing_id}
                                              </Typography>
                                              <br />
                                            </>
                                          )} */}
                                        </>
                                      )}
                                    </div>
                                  </Grid>
                                  {row.sold == 1 ? (
                                    <div
                                      style={{
                                        opacity: "0.4",
                                      }}
                                    >
                                      <Grid container spacing={1}>
                                        <Grid item xs={6} sm={6} md={5}>
                                          <div
                                            style={{
                                              marginTop: "7px",
                                              marginLeft: "10px",
                                              width: "77px",
                                            }}
                                          >
                                            {/* <img src={ebay} alt="ebay" className="img-responsive1" /> */}
                                          </div>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={5}>
                                          {/* <div className="width-100 space-top-10">
                                                                        <img src={Chrono} alt="Chrono" className="img-responsive1" />
                                                                    </div> */}
                                        </Grid>
                                      </Grid>
                                    </div>
                                  ) : null}
                                  {/*    <div > //  <Grid container spacing={1}>
                                                                //    <Grid item xs={6} sm={6} md={5}>
                                                                //     <div style={{marginTop: '7px',marginLeft:'10px',
                                                                //      width: '77px'}}>
                                                                        {/* <img src={ebay} alt="ebay" className="img-responsive1" /> */}
                                  {/* </div>
                                                                    </Grid>
                                                                   <Grid item xs={6} sm={6} md={5}> */}
                                  {/* <div className="width-100 space-top-10">
                                                                        <img src={Chrono} alt="Chrono" className="img-responsive1" />
                                                                    </div> */}
                                  {/*</Grid> 
                                                                    </Grid> 
                                                                    </div>*/}

                                  <Grid item xs={12} sm={12} md={1}></Grid>
                                  <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    style={{
                                      display: "flex",
                                      flexDirection: "row-reverse",
                                    }}
                                  >
                                    {isActionAllowed(
                                      this.state.accessData,
                                      "void_inventory",
                                    ) &&
                                      row?.status === "Active" && (
                                        <BasicMenu
                                          row={row}
                                          searchWatch={
                                            this.SearchInventoryWatchesdetails
                                          }
                                        />
                                      )}
                                    {row?.memoid &&
                                      row?.inventory_status == 3 ? null : (
                                      <>
                                        {isActionAllowed(
                                          this.state.accessData,
                                          "update_sales_status",
                                        ) && (
                                            <>
                                              <FormGroup>
                                                {row.sold_unsold_reason ||
                                                  row.sold_unsold_reason ? (
                                                  <Tooltip
                                                    title={
                                                      row.sold == 1
                                                        ? `${this.state.soldText}${row.sold_unsold_reason}`
                                                        : `${this.state.unsoldText}${row.sold_unsold_reason}`
                                                    }
                                                    placement="top"
                                                  >
                                                    <FormControlLabel
                                                      control={
                                                        <Switch
                                                          checked={row.sold === 1}
                                                          name="Void"
                                                          disabled={
                                                            row.status === "Void"
                                                          }
                                                        />
                                                      }
                                                      onChange={(e) =>
                                                        this.handleSwitch(row, e)
                                                      }
                                                      // label={
                                                      //   row.sold === 1 ? "sold" : "unsold"
                                                      // }
                                                      style={{ margin: "0px" }}
                                                    />
                                                  </Tooltip>
                                                ) : (
                                                  <FormControlLabel
                                                    control={
                                                      <Switch
                                                        checked={row.sold === 1}
                                                        name="Void"
                                                        disabled={
                                                          row.status === "Void"
                                                        }
                                                      />
                                                    }
                                                    onChange={(e) =>
                                                      this.handleSwitch(row, e)
                                                    }
                                                    // label={
                                                    //   row.sold === 1 ? "sold" : "unsold"
                                                    // }
                                                    style={{ margin: "0px" }}
                                                  />
                                                )}
                                              </FormGroup>
                                            </>
                                          )}
                                        {isActionAllowed(
                                          this.state.accessData,
                                          "create_invoice",
                                        ) && (
                                            <>
                                              {row.sold !== 1 &&
                                                row.status !== "Void" && (
                                                  <Button
                                                    variant="contained"
                                                    color="primary"
                                                    className="text-capitalize primary-bg color-white"
                                                    style={{
                                                      marginTop: "4px",
                                                      padding: "4px 6px",
                                                      fontSize: "14px",
                                                    }}
                                                    onClick={() =>
                                                      this.handleOpenModal(
                                                        this.mapInventoryDetails(
                                                          row,
                                                        ),
                                                      )
                                                    }
                                                  >
                                                    Create Invoice
                                                  </Button>
                                                )}
                                            </>
                                          )}
                                      </>
                                    )}
                                    {this.state.setting &&
                                      this.state.setting.sold_price &&
                                      row?.sold == 1 && (
                                        <>
                                          <Typography
                                            variant="p"
                                            className="inventory-tile"
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: 6,
                                              backgroundColor: "#E7F5EC",
                                              color: "#0B8A4A",
                                              padding: "5px 10px",
                                              borderRadius: 8,
                                              height: "30px",
                                              fontWeight: 600,
                                            }}
                                          >
                                            <BookmarkAddedIcon
                                              style={{ fontSize: "17px" }}
                                            />
                                            Sold Price:{" "}
                                            {row?.sold_price
                                              ? "$ " + row?.sold_price
                                              : "--"}
                                          </Typography>
                                          {/* <span></span> */}
                                        </>
                                      )}
                                  </Grid>
                                </Grid>
                              </div>
                            </Grid>
                          </Grid>
                        </Card>
                      </Grid>
                    );
                  })}
                <div
                  style={{
                    position: "fixed",
                    right: "20px",
                    bottom: "20px",
                    marginRight: "3px",
                  }}
                >
                  <Link href="../create-inventory">
                    <img src={plusSign} alt="plusSign" width="53px" />
                  </Link>
                </div>
              </Grid>
              {/* )} */}
            </InfiniteScroll>
          )}
          {inventoryList?.length === 0 &&
            this.state.loaded &&
            this.state.noItemFound && (
              <Box
                component="span"
                sx={{
                  display: "block",
                  border: "2px dashed grey",
                  width: "100%",
                  padding: "50px 72px",
                  // marginTop: "20px",
                }}
              >
                {" "}
                <Container>
                  <Typography
                    variant="h6"
                    className="color-BCBCBC"
                    component="p"
                    align="center"
                  >
                    <b>No Records Found</b>
                  </Typography>
                </Container>
              </Box>
            )}
          {this.state.open && (
            <InvoiceModal
              open={this.state.open}
              handleClose={this.handleClose}
            />
          )}
          {this.state.openReasonChange && (
            <ReasonChange
              open={this.state.openReasonChange}
              handleClose={this.handleCloseOfReasonChange}
              changeRangeName={this.changeRangeName}
            />
          )}
          {this.state.openDeleteModal && (
            <Dialog
              open={this.state.openDeleteModal}
              // onClose={() => this.setState({ openDeleteModal: false })}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              fullWidth={true}
              maxWidth={"sm"}
            >
              <DialogTitle>
                Delete
                <IconButton
                  style={{ float: "right" }}
                  onClick={() =>
                    this.setState({
                      openDeleteModal: false,
                      isDeleteAll: false,
                    })
                  }
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent>
                <div>
                  {" "}
                  Are you sure you want to <b>Delete</b>?{" "}
                </div>
              </DialogContent>
              <DialogActions>
                <Button
                  color="primary"
                  autoFocus
                  onClick={() =>
                    this.setState({
                      openDeleteModal: false,
                      isDeleteAll: false,
                    })
                  }
                >
                  Cancel
                </Button>
                <Button
                  color="primary"
                  onClick={(e) => this.handleOTP(e)}
                  disabled={this.state.disabled}
                >
                  Ok
                </Button>
              </DialogActions>
            </Dialog>
          )}
          {this.state.openOtpModel && (
            <Dialog
              open={this.state.openOtpModel}
              // onClose={() => this.setState({ openOtpModel: false })}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            // fullWidth={true}
            // maxWidth={'sm'}
            >
              <DialogTitle style={{ borderBottom: "1px solid #ccc" }}>
                OTP Verification Code
                <IconButton
                  style={{ float: "right" }}
                  onClick={() =>
                    this.setState({ openOtpModel: false, isDeleteAll: false })
                  }
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent>
                <Container className="space-1">
                  <Paper
                    className="border-radius"
                    style={{ boxShadow: "none" }}
                  >
                    {/* <div className="text-center">
                      <Typography variant="h5" gutterBottom align="center" className="text-white">
                        OTP Verification Code
                      </Typography>
                    </div> */}
                    <div>
                      <Typography variant="small">
                        Please Check your Email for a message with your code.
                        Your Code is 6 digits long.
                      </Typography>
                    </div>
                    <form
                      className="padding"
                      onSubmit={(e) => {
                        e.preventDefault();
                        this.handleVerifyOTP(inventoryList);
                      }}
                      id="otp_form"
                    >
                      <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} md={12}>
                          <FormControl className="form-width-100 ">
                            <InputLabel
                              htmlFor="component-simple"
                              className="color-BCBCBC"
                            >
                              OTP
                            </InputLabel>
                            <Input
                              id="component-simple"
                              onChange={this.onOtpChange}
                            />
                            <FormHelperText className="error-o">
                              {this.state.otpErrorText}
                            </FormHelperText>
                          </FormControl>
                        </Grid>
                        <Button
                          type="submit"
                          className="SubmitColor space-m-1"
                          fullWidth={true}
                          disabled={this.state.disabled}
                        >
                          Verify
                        </Button>
                      </Grid>
                    </form>

                    {this.state.showing ? (
                      <div className="text-center1">
                        <a
                          href="javascript:void(0);"
                          onClick={this.onResendOtp}
                          disableElevation
                          style={{ color: "#CEA05F" }}
                        >
                          <b>Resend OTP </b>
                        </a>
                      </div>
                    ) : (
                      <div className="text-center1">
                        Didn't receive the code? Request New Code in{" "}
                        {this.state.twoMinutes}
                      </div>
                    )}
                    <div className="space-1"></div>
                  </Paper>
                </Container>
              </DialogContent>
              <DialogActions></DialogActions>
            </Dialog>
          )}
          {this.state.openShareModal && (
            <Dialog
              open={this.state.openShareModal}
              // onClose={() => this.setState({ openDeleteModal: false })}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              fullWidth={true}
              maxWidth={"sm"}
            >
              <DialogTitle>
                Share Inventory
                <IconButton
                  style={{ float: "right" }}
                  onClick={() => this.setState({ openShareModal: false })}
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent>
                <div>
                  {" "}
                  Are you sure you want to <b>Share</b> the selected
                  item(s)?{" "}
                </div>
              </DialogContent>
              <DialogActions>
                <Button
                  color="primary"
                  autoFocus
                  onClick={() => this.setState({ openShareModal: false })}
                >
                  Cancel
                </Button>
                <Button
                  color="primary"
                  onClick={(e) => this.handleShareInventory(e)}
                  disabled={this.state.disabled}
                >
                  Ok
                </Button>
              </DialogActions>
            </Dialog>
          )}
          {this.state.openGenerateLabelDialog && (
            <Dialog
              open={this.state.openGenerateLabelDialog}
              onClose={this.handleCloseGenerateLabelDialog}
              fullWidth
              maxWidth="sm"
            >
              <DialogTitle>Choose Fields to Generate Label</DialogTitle>

              <DialogContent dividers>
                <Box display="flex" gap={2}>
                  {/* Column Container with outer border */}
                  <Box
                    display="flex"
                    flex={1}
                    border="1px solid #ccc"
                    borderRadius={1}
                    overflow="hidden"
                  >
                    {/* Left Column */}
                    <Box flex={1} borderRight="1px solid #ccc">
                      <Box p={1}>
                        <Typography
                          variant="subtitle1"
                          style={{ fontWeight: "bold" }}
                        >
                          Left Side (max 2)
                        </Typography>
                      </Box>
                      {getInventoryTileFields().map((field) => (
                        <Box
                          key={field.id}
                          display="flex"
                          alignItems="center"
                          px={1}
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                size="small"
                                value={`left-${field.id}`}
                                checked={this.state.selectedLeftFields?.includes(
                                  field.id,
                                )}
                                onChange={(e) =>
                                  this.handleLabelFieldChange(e, "left")
                                }
                              />
                            }
                            label={
                              <Typography
                                variant="body2"
                                sx={{ textTransform: "uppercase" }}
                              >
                                {field.value}
                              </Typography>
                            }
                          />
                        </Box>
                      ))}
                    </Box>

                    {/* Right Column */}
                    <Box flex={1}>
                      <Box p={1}>
                        <Typography
                          variant="subtitle1"
                          style={{ fontWeight: "bold" }}
                        >
                          Right Side (max 2)
                        </Typography>
                      </Box>
                      {getInventoryTileFields().map((field) => (
                        <Box
                          key={field.id}
                          display="flex"
                          alignItems="center"
                          px={1}
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                size="small"
                                value={`right-${field.id}`}
                                checked={this.state.selectedRightFields?.includes(
                                  field.id,
                                )}
                                onChange={(e) =>
                                  this.handleLabelFieldChange(e, "right")
                                }
                              />
                            }
                            label={
                              <Typography
                                variant="body2"
                                sx={{ textTransform: "uppercase" }}
                              >
                                {field.value}
                              </Typography>
                            }
                          />
                        </Box>
                      ))}
                    </Box>
                  </Box>
                </Box>
                {/* Start Row Input */}
                <Box mt={2} display="flex" gap={2}>
                  <TextField
                    label="Starting Row (1-15)"
                    type="number"
                    value={this.state.startRow}
                    style={{ marginRight: "20px", width: "50%" }}
                    onChange={(e) => {
                      const value = parseInt(e.target.value, 10);

                      if (value >= 1 && value <= 15) {
                        this.setState({ startRow: value });
                      } else if (e.target.value === "") {
                        this.setState({ startRow: "" });
                      }
                    }}
                    inputProps={{ min: 1, max: 15 }}
                  />
                  <TextField
                    label="Quantity (1-9)"
                    type="number"
                    value={this.state.quantity}
                    style={{ width: "50%" }}
                    onChange={(e) => {
                      const value = parseInt(e.target.value, 10);

                      if (value >= 1 && value <= 9) {
                        this.setState({ quantity: value });
                      } else if (e.target.value === "") {
                        this.setState({ quantity: "" });
                      }
                    }}
                    inputProps={{ min: 1, max: 9 }}
                  />
                </Box>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={this.handleCloseGenerateLabelDialog}
                  variant="contained"
                  color="inherit"
                >
                  Cancel
                </Button>

                <Button
                  className="primary-bg color-white"
                  onClick={this.handleGenerateLabel}
                  variant="contained"
                  color="primary"
                  disabled={
                    (this.state.selectedLeftFields?.length || 0) === 0 &&
                    (this.state.selectedRightFields?.length || 0) === 0
                  }
                  style={{
                    opacity:
                      (this.state.selectedLeftFields?.length || 0) === 0 &&
                        (this.state.selectedRightFields?.length || 0) === 0
                        ? 0.4
                        : 1,
                  }}
                >
                  Generate
                </Button>
              </DialogActions>
            </Dialog>
          )}
          {modalOpen && (
            <Modal
              open={modalOpen}
              onClose={this.handleCloseModal}
              aria-labelledby="modal-modal-title"
            >
              <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                  Invoice Type
                </Typography>
                <FormControl fullWidth>
                  {/* <InputLabel htmlFor="component-simple" className="color-BCBCBC">
                  Invoice Type
                </InputLabel> */}
                  <Select
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    onChange={(e) =>
                      this.setState({
                        invoiceType: e.target.value,
                      })
                    }
                    defaultValue={invoiceType}
                    label="Payment Status"
                  >
                    <MenuItem value="regular_invoice">Regular Invoice</MenuItem>
                    <MenuItem value="memo_invoice">Memo Invoice</MenuItem>
                  </Select>
                </FormControl>
                <Box style={{ display: "flex", justifyContent: "flex-end" }}>
                  <Button
                    type="submit"
                    variant="text"
                    style={{
                      background: "#000",
                      color: "#fff",
                      marginTop: "20px",
                      marginRight: "10px",
                    }}
                    onClick={() => {
                      const path =
                        invoiceType === "regular_invoice"
                          ? "/create/invoice"
                          : "/create/memoinvoice";
                      this.props.history.push({
                        pathname: path,
                        state: { inventoryDetails: selectedInventoryData },
                      });
                    }}
                  >
                    Create
                  </Button>
                  &nbsp;
                  <Button
                    variant="outlined"
                    onClick={this.handleCloseModal}
                    style={{
                      background: "#fff",
                      color: "#000",
                      marginTop: "20px",
                      paddingTop: "5 !important",
                      paddingBottom: "5 !important",
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </Box>
            </Modal>
          )}
          {/* <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={inventoryList.length}
            rowsPerPage={this.state.rowsPerPage}
            SelectProps={{
              native: true
            }}
            page={this.state.page}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
          /> */}
        </Container>
        {/* </Loader> */}
        {this.renderShopifySyncLoader()}

        <ShopifySyncResultDialog
          open={this.state.showShopifyResultDialog}
          onClose={() =>
            this.setState({
              showShopifyResultDialog: false,
              selectedItems: [],
              selectAll: false,
            })
          }
          results={this.state.shopifySyncResult}
          mapInventoryIdToLabel={(id) =>
            this.state.inventoryMap?.[id] || `${id}`
          }
          onRetryFailed={(failedIds) => {
            this.setState(
              {
                showShopifyResultDialog: false,
                selectedItems: [],
                selectAll: false,
              },
              () => {
                this.handleRetryShopify(failedIds);
              },
            );
          }}
        />
        <ShopifySyncResultDialog
          platformName="eBay"
          open={this.state.showEbayResultDialog}
          onClose={() => {
            this.setState({ selectedItems: [], selectAll: false, showShopifyResultDialog: false, showEbayResultDialog: false });
            // this.SearchInventoryWatchesdetails();
          }}
          results={this.state.ebaySyncResult}
          mapInventoryIdToLabel={(id) =>
            this.state.inventoryMap?.[id] || `${id}`
          }
          onRetryFailed={(failedIds) => {
            this.setState(
              {
                showEbayResultDialog: false,
                selectedItems: [],
                selectAll: false,
              },
              () => {
                this.handleRetryEbay(failedIds);
              },
            );
          }}
        />
      </div>
    );
  }

  render() {
    return (
      <ContentWrapper
        contentView={
          this.state.userData &&
            (!this.state.userData?.planDetails ||
              this.state.userData?.planDetails === "Noplan") &&
            (!this.state.userData?.dealerInventorySubscription ||
              this.state.userData?.dealerInventorySubscription ===
              "access_only" ||
              this.state.userData?.dealerInventorySubscription ===
              "no_subscription" ||
              this.state.userData?.isDealerInventoryExpired === true) ? (
            <div style={{ marginTop: "25px" }}>
              {" "}
              <UpgradePlan />{" "}
            </div>
          ) : (
            this.inventoryrender()
          )
        }
      ></ContentWrapper>
    );
  }
}

function mapStateToProps(state) {
  const { InventoryList, auth, browseWatchesInfo, inventoryDetailByIdInfo } =
    state;
  return {
    InventoryList: InventoryList.InventoryList,
    currentUser: auth.currentUser,
    // dialColorInfo: browseWatchesInfo.dialColorInfo,
    brandInfo: browseWatchesInfo.brandInfo,
    inventoryXlIdInfo: InventoryList.inventoryXlIdInfo,
    // inventoryDetailByIdInfo: inventoryDetailByIdInfo.inventoryDetailByIdInfo
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchInventoryWatches,
      filterBySearch,
      brandList,
      inventoryDetailById,
      fetchInventoryExcelList,
      SearchInventoryWatches,
      sendToShopify,
      recoverPassword,
      verifyOtp,
      // dialColor,
    },
    dispatch,
  );
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withStyles(styles)(InventoryComponent)),
);
